// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════════════
   HEALTHMAP — Theme Variables
   ═══════════════════════════════════════════════════════════ */
.healthmap-page[data-theme="light"],
.hm-theme-light {
  --hm-bg: #F8F9FA;
  --hm-surface: #FFFFFF;
  --hm-surface-hover: #F1F3F5;
  --hm-text: #212529;
  --hm-text-secondary: #495057;
  --hm-text-muted: #ADB5BD;
  --hm-border: #E9ECEF;
  --hm-border-hover: #DEE2E6;
  --hm-line: #E9ECEF;
  --hm-line-fill: #E62121;
  --hm-dot: #DEE2E6;
  --hm-dot-active: #E62121;
  --hm-accent: #E62121;
  --hm-accent-2: #e34444;
  --hm-accent-rgb: 230, 33, 33;
  --hm-accent-gradient: linear-gradient(135deg, #E62121 0%, #FF6B6B 100%);
  --hm-accent-soft: rgba(230, 33, 33, 0.08);
  --hm-overlay-bg: rgba(0, 0, 0, 0.4);
  --hm-card-shadow: 0 2px 8px rgba(0, 0, 0, 0.04), 0 8px 16px rgba(0, 0, 0, 0.04);
  --hm-card-shadow-hover: 0 4px 12px rgba(0, 0, 0, 0.06), 0 12px 24px rgba(0, 0, 0, 0.06);
  --hm-rx-accent: #E62121;
  --hm-rcpt-accent: #228BE6;
  --hm-order-accent: #40C057;
  --hm-record-accent: #FAB005;
  --hm-image-accent: #10B981;
  /* Emerald Green */
  --hm-treatment-accent: #6366F1;
  /* Indigo Blue */
  --hm-search-bg: #FFFFFF;
  --hm-tag-bg: #F1F3F5;
  --hm-tag-text: #495057;
  --hm-today-bg: rgba(255, 255, 255, 0.4);
  /* Glassmorphism Refined */
  --hm-banner-glass: rgba(255, 255, 255, 0.75);
  --hm-card-glass: rgba(255, 255, 255, 0.45);
  --hm-glass-border: rgba(255, 255, 255, 0.4);
  --hm-glass-highlight: rgba(255, 255, 255, 0.8);
  --hm-glass-glow: rgba(255, 255, 255, 0.4);
}

.healthmap-page[data-theme="dark"],
.hm-theme-dark {
  --hm-bg: #101113;
  --hm-surface: #1A1B1E;
  --hm-surface-hover: #25262B;
  --hm-text: #E9ECEF;
  --hm-text-secondary: #C1C2C5;
  --hm-text-muted: #909296;
  --hm-border: #2C2E33;
  --hm-border-hover: #373A40;
  --hm-line: #2C2E33;
  --hm-line-fill: #E62121;
  --hm-dot: #373A40;
  --hm-dot-active: #E62121;
  --hm-accent: #FF6B6B;
  --hm-accent-2: #df4a4a;
  --hm-accent-rgb: 255, 107, 107;
  --hm-accent-gradient: linear-gradient(135deg, #FF6B6B 0%, #FFA8A8 100%);
  --hm-accent-soft: rgba(255, 107, 107, 0.12);
  --hm-overlay-bg: rgba(0, 0, 0, 0.8);
  --hm-card-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
  --hm-card-shadow-hover: 0 8px 24px rgba(0, 0, 0, 0.5);
  --hm-rx-accent: #FF6B6B;
  --hm-rcpt-accent: #4DABF7;
  --hm-order-accent: #69DB7C;
  --hm-record-accent: #FFD43B;
  --hm-image-accent: #34D399;
  /* Emerald Green */
  --hm-treatment-accent: #818CF8;
  /* Indigo Blue */
  --hm-search-bg: #1A1B1E;
  --hm-tag-bg: #25262B;
  --hm-tag-text: #C1C2C5;
  --hm-today-bg: rgba(26, 27, 30, 0.4);
  /* Glassmorphism Refined */
  --hm-banner-glass: rgba(26, 27, 30, 0.85);
  --hm-card-glass: rgba(26, 27, 30, 0.6);
  --hm-glass-border: rgba(255, 255, 255, 0.08);
  --hm-glass-highlight: rgba(255, 255, 255, 0.15);
  --hm-glass-glow: rgba(255, 255, 255, 0.05);
}

/* ═══════════════════════════════════════════════════════════
   Base Layout
   ═══════════════════════════════════════════════════════════ */
.healthmap-page {
  min-height: 100vh;
  background: var(--hm-bg);
  /* Added mesh gradient to enhance glassmorphism */
  background-image:
    radial-gradient(at 0% 0%, var(--hm-accent-soft) 0, transparent 50%),
    radial-gradient(at 50% 0%, var(--hm-rcpt-accent-soft, rgba(34, 139, 230, 0.05)) 0, transparent 50%),
    radial-gradient(at 100% 0%, var(--hm-order-accent-soft, rgba(64, 192, 87, 0.05)) 0, transparent 50%);
  color: var(--hm-text);
  transition: background 0.4s ease, color 0.4s ease;
  font-family: "Poppins", sans-serif;
  width: calc(100% + 32px);
  margin: -16px -16px -16px -16px;
  position: relative;
  padding-top: 16px;
  /* Controlled padding instead of margin gap */
}

/* Header removed as per request */
.theme-icon {
  font-size: 14px;
  opacity: 0.8;
}

/* ═══════════════════════════════════════════════════════════
   Theme Toggle
   ═══════════════════════════════════════════════════════════ */
.theme-toggle {
  width: 44px;
  height: 24px;
  border-radius: 12px;
  background: var(--hm-border);
  border: none;
  cursor: pointer;
  position: relative;
  transition: background 0.3s ease;
  flex-shrink: 0;
}

.theme-toggle::after {
  content: "";
  position: absolute;
  top: 3px;
  left: 3px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: var(--hm-accent);
  transition: transform 0.3s ease;
}

.healthmap-page[data-theme="dark"] .theme-toggle {
  background: #3D3650;
}

.healthmap-page[data-theme="dark"] .theme-toggle::after {
  transform: translateX(20px);
}

/* ═══════════════════════════════════════════════════════════
   Patient Search Phase
   ═══════════════════════════════════════════════════════════ */
.search-phase {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 40px 24px;
  position: relative;
}

.search-phase-controls {
  position: absolute;
  top: 0;
  /* Flush with top */
  left: 24px;
  right: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.search-theme-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  background: var(--hm-today-bg);
  padding: 6px 12px;
  border-radius: 12px;
  border: 1px solid var(--hm-border);
}

/* ═══════════════════════════════════════════════════════════
   Background Decorations
   ═══════════════════════════════════════════════════════════ */
.hm-bg-decorations {
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
  z-index: 0;
}

.hm-decor-item {
  position: absolute;
  width: 48px;
  height: 48px;
  color: var(--hm-text);
  opacity: 0.04;
  /* Extremely subtle */
  filter: blur(1px);
  will-change: transform;
}

.healthmap-page[data-theme="dark"] .hm-decor-item {
  opacity: 0.08;
  /* Slightly more visible in dark mode */
}

.search-title {
  font-size: 32px;
  font-weight: 800;
  color: var(--hm-text);
  margin-bottom: 12px;
  letter-spacing: -1px;
}

.search-subtitle {
  font-size: 16px;
  color: var(--hm-text-muted);
  margin-bottom: 40px;
}

.search-container {
  position: relative;
  width: 100%;
  max-width: 520px;
}

.search-input {
  width: 100%;
  padding: 20px 24px 20px 56px;
  border-radius: 20px;
  border: 2px solid var(--hm-border);
  background: var(--hm-search-bg);
  color: var(--hm-text);
  font-size: 18px;
  font-family: "Poppins", sans-serif;
  outline: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
}

.search-input:focus {
  border-color: var(--hm-accent);
  box-shadow: 0 15px 40px rgba(230, 33, 33, 0.1);
  transform: translateY(-2px);
}

.search-input::placeholder {
  color: var(--hm-text-muted);
}

.search-icon {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--hm-text-muted);
  pointer-events: none;
}

.search-dropdown {
  position: absolute;
  top: calc(100% + 12px);
  left: 0;
  right: 0;
  background: var(--hm-surface);
  border-radius: 20px;
  border: 1px solid var(--hm-border);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);
  max-height: 400px;
  overflow-y: auto;
  z-index: 100;
  padding: 8px;
  backdrop-filter: blur(20px);
}

.search-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  cursor: pointer;
  transition: all 0.2s ease;
  border-radius: 12px;
  margin-bottom: 4px;
}

.search-item:last-child {
  margin-bottom: 0;
}

.search-item:hover {
  background: var(--hm-accent);
}

.search-item:hover .search-item-name,
.search-item:hover .search-item-phone,
.search-item:hover .search-item-city {
  color: #FFFFFF;
}

.search-item-name {
  font-weight: 500;
  font-size: 14px;
  color: var(--hm-text);
}

.search-item-phone {
  font-size: 13px;
  color: var(--hm-text-muted);
  font-family: monospace;
}

.search-item-city {
  font-size: 12px;
  color: var(--hm-text-muted);
}

.search-loading {
  padding: 20px;
  text-align: center;
  color: var(--hm-text-muted);
  font-size: 13px;
}

/* ═══════════════════════════════════════════════════════════
   Patient Banner
   ═══════════════════════════════════════════════════════════ */
.patient-banner {
  background: var(--hm-banner-glass);
  border: 1px solid var(--hm-glass-border);
  border-radius: 24px;
  padding: 12px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 24px 32px;

  /* Advanced Glass Shadow Stack */
  box-shadow:
    0 12px 30px rgba(0, 0, 0, 0.08),
    inset 1px 1px 0px var(--hm-glass-highlight),
    /* Light hit on top-left edge */
    inset 0 0 12px var(--hm-glass-glow);
  /* Subtle inner glow */

  position: sticky;
  top: 16px;
  z-index: 100;

  backdrop-filter: blur(28px) saturate(200%);
  -webkit-backdrop-filter: blur(28px) saturate(200%);

  /* Simulated light refraction on left side */
  background-image: linear-gradient(110deg,
      rgba(255, 255, 255, 0.1) 0%,
      transparent 40%);
}

/* ─── Firm Branding: Hyperapt (Header) ─── */
.hyperapt-brand-logo {
  display: flex;
  align-items: center;
  margin-right: 12px;
  padding-right: 12px;
  border-right: 1px solid var(--hm-border);
  cursor: default;
}

.firm-primary {
  font-size: 24px;
  font-weight: 300;
  color: var(--hm-accent);
}

/* ─── Remade Integrated Feature Title (Strict Axis) ─── */
.today-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 28px;
  /* Parent container centering */
}

.healthmap-integrated-logo {
  display: flex;
  align-items: center;
  height: 22px;
  /* Fixed height for the entire wordmark axis */
}

.healthmap-integrated-logo .feature-mark-pulse {
  width: 24px;
  height: 22px;
  /* Matches text height exactly */
  color: var(--hm-text);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: -4px;
}

.healthmap-integrated-logo .feature-mark-pulse svg {
  width: 20px;
  /* Scaled to sit inside the 22px height */
  height: 20px;
}

.healthmap-integrated-logo .brand-primary,
.healthmap-integrated-logo .brand-secondary {
  font-size: 22px;
  font-weight: 600;
  color: var(--hm-text);
  letter-spacing: -0.6px;
  line-height: 22px;
  /* Matches height exactly */
  display: block;
}

.healthmap-integrated-logo .brand-secondary {
  font-weight: 400;
  color: var(--hm-text);
}

.header-divider {
  height: 16px;
  width: 1.5px;
  background-color: var(--hm-border);
  opacity: 0.8;
  border-radius: 2px;
}

.today-label {
  font-size: 14px;
  font-weight: 700;
  color: var(--hm-accent);
  text-transform: uppercase;
  letter-spacing: 1px;
  line-height: 0px;
  /* Matches logo height exactly for alignment */
  display: block;
  opacity: 0.9;
  margin-top: 18px;
}

/* Sidebar Toggle Overrides */
.patient-banner button.flex,
.search-phase-controls button.flex {
  background: transparent !important;
  color: var(--hm-text) !important;
}

.patient-banner button.flex:hover,
.search-phase-controls button.flex:hover {
  background: var(--hm-surface-hover) !important;
  transform: scale(1.05) !important;
}

.patient-banner button.flex svg,
.search-phase-controls button.flex svg {
  fill: none !important;
  stroke: var(--hm-text) !important;
  /* Menu icon uses stroke, not fill */
  transition: stroke 0.3s ease;
}

.patient-banner button.flex svg path,
.search-phase-controls button.flex svg path {
  stroke: var(--hm-text) !important;
}

.patient-banner-left {
  display: flex;
  align-items: center;
  gap: 20px;
}


.patient-banner-main {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.patient-banner-name {
  font-size: 20px;
  /* Slightly smaller */
  font-weight: 700;
  color: var(--hm-text);
  letter-spacing: -0.5px;
  margin: 0;
}

.patient-banner-tags {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.patient-tag {
  font-size: 11px;
  font-weight: 600;
  padding: 2px 10px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.patient-tag.age,
.patient-tag.gender,
.patient-tag.phone {
  background: var(--hm-tag-bg);
  color: var(--hm-tag-text);
}

.patient-banner-right {
  display: flex;
  align-items: center;
  gap: 24px;
}

.patient-location {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-right: 24px;
  border-right: 1px solid var(--hm-border);
}

.location-icon {
  font-size: 18px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.05));
}

.location-city {
  font-size: 13px;
  font-weight: 700;
  color: var(--hm-text);
}

.location-pin {
  font-size: 11px;
  color: var(--hm-text-muted);
  font-weight: 500;
}

.patient-banner-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.banner-theme-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--hm-bg);
  padding: 4px 10px;
  border-radius: 10px;
  border: 1px solid var(--hm-border);
}

.change-patient-btn {
  padding: 8px 16px;
  border-radius: 10px;
  border: 1px solid var(--hm-border);
  background: var(--hm-surface);
  color: var(--hm-text);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;
}

.change-patient-btn:hover {
  background: var(--hm-accent-soft);
  border-color: var(--hm-accent);
  color: var(--hm-accent);
  transform: translateY(-2px);
}

/* ═══════════════════════════════════════════════════════════
   HealthMap Container
   ═══════════════════════════════════════════════════════════ */
.healthmap-container {
  padding: 32px 24px 100px;
  max-width: 1000px;
  margin: 0 auto;
}

/* ═══════════════════════════════════════════════════════════
   HealthMap Bar & Milestones
   ═══════════════════════════════════════════════════════════ */
.healthmap-list {
  position: relative;
  padding-left: 140px;
}

.healthmap-line {
  position: absolute;
  left: 138px;
  top: 11px;
  bottom: 0;
  width: 4px;
  background: var(--hm-line);
  border-radius: 4px;
}

.healthmap-line-fill {
  position: absolute;
  left: 138px;
  bottom: 0;
  /* Anchor to bottom */
  width: 4px;
  background: linear-gradient(to top,
      var(--hm-accent-soft) 0%,
      var(--hm-accent) 70%,
      #ff6b6b 100%);
  z-index: 5;
  border-radius: 2px;
  transform-origin: bottom;
  will-change: height;
  box-shadow: 0 0 15px rgba(230, 33, 33, 0.4);
}

.healthmap-line-fill::after {
  content: "";
  position: absolute;
  top: -4px;
  /* Dot at the top of the fill */
  left: 50%;
  transform: translateX(-50%);
  width: 8px;
  height: 8px;
  background: #ff6b6b;
  border-radius: 50%;
  box-shadow: 0 0 10px #ff6b6b, 0 0 20px #ff6b6b;
  z-index: 6;
}

.healthmap-entry {
  position: relative;
  padding-bottom: 20px;
  padding-left: 48px;
  animation: entryFadeIn 0.5s ease-out both;
  z-index: 10;
  /* Added perspective here for children transforms */
  perspective: 1200px;
}

.healthmap-entry.today-entry {
  z-index: 50;
}

.healthmap-entry.today-entry.filter-open,
.healthmap-entry.today-entry:has(.today-filter-dropdown) {
  z-index: 500;
}

@keyframes entryFadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.healthmap-date {
  position: absolute;
  left: -140px;
  top: 2px;
  width: 120px;
  text-align: right;
  font-size: 12px;
  font-weight: 500;
  color: var(--hm-text-muted);
  line-height: 1.3;
}

.healthmap-date-day {
  font-size: 13px;
  font-weight: 600;
  color: var(--hm-text-secondary);
}

.healthmap-line,
.healthmap-line-fill {
  left: 130px;
  /* Shifted left slightly since dots are gone */
}

.healthmap-dot.record {
  border-color: var(--hm-record-accent);
}

/* ═══════════════════════════════════════════════════════════
   HealthMap Cards
   ═══════════════════════════════════════════════════════════ */
.hm-card-wrapper {
  will-change: transform, opacity;
  transform-style: preserve-3d;
}

.hm-card {
  background: var(--hm-card-glass);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border-radius: 16px;
  border: 1px solid var(--hm-glass-border);
  padding: 20px;
  box-shadow: var(--hm-card-shadow);
  transition: box-shadow 0.3s ease, border-color 0.3s ease;
  cursor: default;
  position: relative;
  overflow: hidden;
  will-change: transform, opacity;
}

.hm-card:hover {
  box-shadow: var(--hm-card-shadow-hover);
  border-color: var(--hm-accent);
  transform: translateY(-2px);
}

.hm-card::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: transparent;
  transition: background 0.3s ease;
}

.hm-card.prescription:hover::before {
  background: var(--hm-rx-accent);
}

.hm-card.receipt:hover::before {
  background: var(--hm-rcpt-accent);
}

.hm-card.order:hover::before {
  background: var(--hm-order-accent);
}

.hm-card.record:hover::before {
  background: var(--hm-record-accent);
}

.hm-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.hm-card-type {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.hm-card-type.prescription {
  color: var(--hm-rx-accent);
}

.hm-card-type.receipt {
  color: var(--hm-rcpt-accent);
}

.hm-card-type.order {
  color: var(--hm-order-accent);
}

.hm-card-type.record {
  color: var(--hm-record-accent);
}

.hm-card-id {
  font-size: 12px;
  font-weight: 500;
  color: var(--hm-text-muted);
  font-family: monospace;
}

.hm-card-body {
  font-size: 13px;
  color: var(--hm-text-secondary);
  line-height: 1.5;
}

.hm-card-row {
  display: flex;
  align-items: baseline;
  gap: 6px;
  margin-bottom: 4px;
}

.hm-card-label {
  font-size: 11px;
  font-weight: 600;
  color: var(--hm-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.3px;
  flex-shrink: 0;
}

.hm-card-value {
  font-size: 13px;
  color: var(--hm-text);
}

.hm-card-products {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 6px;
}

.hm-product-pill {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 6px;
  background: var(--hm-accent-soft);
  color: var(--hm-text-secondary);
  white-space: nowrap;
}

.hm-card-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px solid var(--hm-border);
}

.hm-action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: none;
  background: transparent;
  color: var(--hm-text-muted);
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
}

.hm-action-btn:hover {
  background: var(--hm-accent-soft);
  color: var(--hm-accent);
}

.hm-action-whatsapp:hover {
  background: rgba(37, 211, 102, 0.1);
}

.hm-action-whatsapp-btn {
  display: flex;
  align-items: center;
  gap: 6px;
}

.hm-action-whatsapp-btn:hover {
  background: rgba(37, 211, 102, 0.12) !important;
  border-color: rgba(37, 211, 102, 0.3) !important;
}

/* ═══════════════════════════════════════════════════════════
   Prescription Health Records (in card)
   ═══════════════════════════════════════════════════════════ */
.hm-health-records {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 10px;
}

.hm-hr-item {
  padding: 6px 8px;
  border-radius: 8px;
  background: var(--hm-bg);
  border: 1px solid var(--hm-border);
}

.hm-hr-item.hr-complaints,
.hm-hr-item.hr-diagnosis,
.hm-hr-item.hr-measurements,
.hm-hr-item.hr-tests,
.hm-hr-item.hr-advice,
.hm-hr-item.hr-observations,
.hm-hr-item.hr-notes,
.hm-hr-item.hr-nextvisit,
.hm-hr-item.hr-diagrams,
.hm-hr-item.hr-medicines {
  border-left: 3px solid var(--hm-border-hover);
}

.hm-hr-header {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 3px;
}

.hm-hr-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 4px;
  flex-shrink: 0;
}

.hr-complaints .hm-hr-icon {
  color: #E62121;
}

.hr-diagnosis .hm-hr-icon {
  color: #0F52BA;
}

.hr-measurements .hm-hr-icon {
  color: #D97706;
}

.hr-tests .hm-hr-icon {
  color: #6366F1;
}

.hr-advice .hm-hr-icon {
  color: #00C732;
}

.hr-observations .hm-hr-icon {
  color: #9333EA;
}

.hr-notes .hm-hr-icon {
  color: #6B7280;
}

.hr-nextvisit .hm-hr-icon {
  color: #3B82F6;
}

.hr-diagrams .hm-hr-icon {
  color: #6366F1;
}

.hr-medicines .hm-hr-icon {
  color: #0D9488;
}

.hm-hr-label {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--hm-text-muted);
}

.hm-hr-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
}

.hm-hr-pill {
  font-size: 11px;
  padding: 1px 7px;
  border-radius: 5px;
  background: var(--hm-surface);
  color: var(--hm-text-secondary);
  border: 1px solid var(--hm-border);
  white-space: nowrap;
}

.hm-hr-text {
  font-size: 12px;
  color: var(--hm-text-secondary);
  line-height: 1.4;
}

/* ═══════════════════════════════════════════════════════════
   Diagrams Grid
   ═══════════════════════════════════════════════════════════ */
.hm-diagram-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
  gap: 10px;
  margin-top: 4px;
}

.hm-diagram-preview {
  position: relative;
  aspect-ratio: 1;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid var(--hm-border);
  cursor: zoom-in;
  background: #fff;
  transition: all 0.2s ease;
}

.hm-diagram-preview:hover {
  transform: scale(1.05);
  border-color: var(--hm-accent);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.hm-diagram-preview img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.hm-diagram-info {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0.4) 60%, transparent 100%);
  padding: 12px 6px 6px;
  display: flex;
  flex-direction: column;
}

.hm-diag-meta {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.hm-diag-title {
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.hm-diag-sub {
  color: rgba(255, 255, 255, 0.8);
  font-size: 8px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.hm-diag-val {
  color: rgba(255, 255, 255, 0.9);
  font-size: 8px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 1px;
}

.hm-hr-item.hr-images {
  border-color: rgba(16, 185, 129, 0.2);
  background: rgba(16, 185, 129, 0.03);
}

.hm-hr-item.hr-images .hm-hr-label {
  color: var(--hm-image-accent);
}

.hm-hr-item.hr-images .hm-hr-icon {
  color: var(--hm-image-accent);
}

.hm-diagram-preview.patient-image {
  border-radius: 12px;
  border: 1.5px solid rgba(16, 185, 129, 0.15);
}

.hm-diagram-preview.patient-image:hover {
  border-color: var(--hm-image-accent);
  transform: scale(1.02);
}

.hm-hr-item.hr-treatment {
  border-color: rgba(99, 102, 241, 0.2);
  background: rgba(99, 102, 241, 0.03);
}

.hm-hr-item.hr-treatment .hm-hr-label {
  color: var(--hm-treatment-accent);
}

.hm-hr-item.hr-treatment .hm-hr-icon {
  color: var(--hm-treatment-accent);
}

/* ═══════════════════════════════════════════════════════════
   Medicine Card Styles
   ═══════════════════════════════════════════════════════════ */
.medicine-list {
  display: flex;
  flex-direction: column;
  gap: 8px !important;
}

.hm-medicine-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background: var(--hm-surface-hover);
  border-radius: 8px;
  border: 1px solid var(--hm-border);
  gap: 12px;
}

.hm-med-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--hm-text);
  flex: 1 1;
}

.hm-med-details {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.hm-med-dosage {
  font-size: 12px;
  color: var(--hm-rx-accent);
  font-weight: 600;
  background: var(--hm-accent-soft);
  padding: 2px 8px;
  border-radius: 4px;
}

.hm-med-days {
  font-size: 11px;
  color: var(--hm-text-muted);
  font-weight: 500;
}

/* ═══════════════════════════════════════════════════════════
   Doctor Tag
   ═══════════════════════════════════════════════════════════ */
.doctor-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  padding: 3px 10px;
  border-radius: 6px;
  background: var(--hm-tag-bg);
  color: var(--hm-tag-text);
  margin-top: 8px;
  font-weight: 500;
}

/* ═══════════════════════════════════════════════════════════
   Order Status Badge
   ═══════════════════════════════════════════════════════════ */
.order-status {
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 6px;
  text-transform: uppercase;
}

.order-status.delivered,
.order-status.collected {
  background: rgba(0, 199, 50, 0.12);
  color: #00C732;
}

.order-status.packed,
.order-status.dispatched {
  background: rgba(15, 82, 186, 0.12);
  color: #0F52BA;
}

.order-status.accepted {
  background: rgba(199, 166, 0, 0.12);
  color: #C7A600;
}

.order-status.cancelled {
  background: rgba(230, 33, 33, 0.12);
  color: #E62121;
}

/* ═══════════════════════════════════════════════════════════
   Today Milestone
   ═══════════════════════════════════════════════════════════ */
.today-milestone {
  background: var(--hm-today-bg);
  border-radius: 20px;
  border: 1px solid var(--hm-border);
  padding: 24px;
  box-shadow: var(--hm-card-shadow);
}

.today-label {
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: var(--hm-accent);
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.today-label::after {
  content: "";
  flex: 1 1;
  height: 1px;
  background: linear-gradient(to right, var(--hm-accent-soft), transparent);
}

.today-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.today-action-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 18px;
  border-radius: 12px;
  border: 1px solid var(--hm-border);
  background: var(--hm-surface);
  color: var(--hm-text);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  font-family: "Poppins", sans-serif;
  white-space: nowrap;
}

.today-action-btn:hover {
  border-color: var(--hm-accent);
  background: var(--hm-accent);
  color: #FFFFFF;
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(230, 33, 33, 0.2);
}

.today-action-btn.studio-jump {
  border-style: dashed;
  color: var(--hm-text-secondary);
}

.today-action-btn.studio-jump:hover {
  background: linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%);
  border-color: transparent;
  border-style: solid;
  color: #FFFFFF;
  box-shadow: 0 8px 20px rgba(99, 102, 241, 0.3);
}

/* ═══════════════════════════════════════════════════════════
   HealthMap Timeline Filters Dropdown
   ═══════════════════════════════════════════════════════════ */
.today-filter-container {
  position: relative;
  display: inline-flex;
  z-index: 50;
}

.today-filter-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border-radius: 12px;
  border: 1px solid var(--hm-border);
  background: var(--hm-surface);
  color: var(--hm-text);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  font-family: "Poppins", sans-serif;
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
}

.today-filter-btn:hover {
  border-color: var(--hm-border-hover);
  background: var(--hm-surface-hover);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.today-filter-btn.open {
  border-color: var(--hm-accent);
  box-shadow: 0 4px 14px rgba(230, 33, 33, 0.15);
}

.today-filter-btn.is-filtered {
  border-color: var(--hm-accent);
  background: var(--hm-accent-soft);
  color: var(--hm-accent);
}

.today-filter-btn .today-filter-icon {
  flex-shrink: 0;
  opacity: 0.85;
}

.today-filter-badge {
  font-size: 11px;
  font-weight: 700;
  padding: 2px 7px;
  border-radius: 8px;
  letter-spacing: 0.3px;
  transition: all 0.2s ease;
}

.today-filter-badge.all {
  background: var(--hm-tag-bg);
  color: var(--hm-text-secondary);
}

.today-filter-badge.filtered {
  background: var(--hm-accent);
  color: #FFFFFF;
  box-shadow: 0 2px 6px rgba(230, 33, 33, 0.3);
}

.today-filter-chevron {
  font-size: 9px;
  opacity: 0.6;
  transition: transform 0.25s ease;
  margin-left: 2px;
}

.today-filter-chevron.open {
  transform: rotate(180deg);
}

/* Dropdown Popover */
.today-filter-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  min-width: 290px;
  max-width: 330px;
  background: var(--hm-surface);
  border: 1px solid var(--hm-border);
  border-radius: 16px;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.22), 0 4px 16px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  padding: 12px;
  z-index: 500;
  animation: hmFilterDropdownFade 0.22s cubic-bezier(0.16, 1, 0.3, 1);
}

.today-filter-dropdown.align-right {
  right: 0;
  left: auto;
  transform-origin: top right;
}

.today-filter-dropdown.align-left {
  left: 0;
  right: auto;
  transform-origin: top left;
}

@keyframes hmFilterDropdownFade {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(-6px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.today-filter-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 6px 10px 8px;
  border-bottom: 1px solid var(--hm-border);
  margin-bottom: 8px;
}

.today-filter-title {
  font-size: 13px;
  font-weight: 700;
  color: var(--hm-text);
  letter-spacing: -0.2px;
}

.today-filter-toggle-btn {
  background: transparent;
  border: none;
  font-size: 12px;
  font-weight: 600;
  color: var(--hm-accent);
  cursor: pointer;
  padding: 3px 8px;
  border-radius: 6px;
  font-family: "Poppins", sans-serif;
  transition: background 0.2s ease;
}

.today-filter-toggle-btn:hover {
  background: var(--hm-accent-soft);
}

.today-filter-list {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.today-filter-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 9px 10px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.18s ease;
  -webkit-user-select: none;
          user-select: none;
}

.today-filter-item:hover {
  background: var(--hm-surface-hover);
}

.today-filter-item.selected {
  background: rgba(var(--hm-accent-rgb), 0.04);
}

.today-filter-item-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.today-filter-checkbox {
  width: 18px;
  height: 18px;
  border-radius: 5px;
  border: 1.8px solid var(--hm-border-hover);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  background: var(--hm-bg);
  flex-shrink: 0;
}

.today-filter-checkbox.checked {
  background: var(--hm-accent);
  border-color: var(--hm-accent);
  color: #FFFFFF;
}

.today-filter-item-icon {
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.today-filter-item-label {
  font-size: 13px;
  font-weight: 500;
  color: var(--hm-text);
}

.today-filter-item-count {
  font-size: 11px;
  font-weight: 600;
  padding: 2px 7px;
  border-radius: 10px;
  background: var(--hm-tag-bg);
  color: var(--hm-tag-text);
  min-width: 22px;
  text-align: center;
}

.today-filter-item-count.zero {
  opacity: 0.45;
}

.today-filter-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 8px 2px;
  border-top: 1px solid var(--hm-border);
  margin-top: 8px;
}

.today-filter-footer-text {
  font-size: 11px;
  color: var(--hm-text-muted);
}

.today-filter-reset-link {
  background: transparent;
  border: none;
  font-size: 11px;
  font-weight: 600;
  color: var(--hm-accent);
  cursor: pointer;
  padding: 2px 6px;
  border-radius: 4px;
  font-family: "Poppins", sans-serif;
}

.today-filter-reset-link:hover {
  text-decoration: underline;
}

/* ═══════════════════════════════════════════════════════════
   Overlay (for Prescription/Receipt/PDF)
   ═══════════════════════════════════════════════════════════ */
.hm-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  background: var(--hm-overlay-bg);
  animation: overlayFadeIn 0.3s ease;
}

@keyframes overlayFadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.hm-overlay-panel {
  background: var(--hm-surface);
  border-radius: 16px;
  width: 95%;
  max-width: 860px;
  max-height: 92vh;
  overflow-y: auto;
  box-shadow: 0 16px 64px rgba(0, 0, 0, 0.2);
  animation: panelSlideUp 0.35s ease;
  position: relative;
}

@keyframes panelSlideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.hm-overlay-close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: var(--hm-border);
  color: var(--hm-text-secondary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  transition: all 0.2s ease;
  z-index: 10;
}

.hm-overlay-close:hover {
  background: var(--hm-accent);
  color: #fff;
}

.hm-overlay-title {
  font-size: 18px;
  font-weight: 600;
  padding: 20px 24px 0;
  color: var(--hm-text);
}

.hm-overlay-body {
  padding: 16px 24px 24px;
}

/* ═══════════════════════════════════════════════════════════
   PDF Overlay
   ═══════════════════════════════════════════════════════════ */
.pdf-overlay-frame {
  width: 100%;
  height: 75vh;
  border: none;
  border-radius: 8px;
  background: #fff;
}

.pdf-overlay-actions {
  display: flex;
  gap: 8px;
  padding: 16px 24px;
  border-top: 1px solid var(--hm-border);
  justify-content: center;
}

/* ═══════════════════════════════════════════════════════════
   Record Editor
   ═══════════════════════════════════════════════════════════ */
.record-textarea {
  width: 100%;
  min-height: 80px;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid var(--hm-border);
  background: var(--hm-bg);
  color: var(--hm-text);
  font-size: 13px;
  font-family: "Poppins", sans-serif;
  resize: vertical;
  outline: none;
  transition: border-color 0.2s ease;
}

.record-textarea:focus {
  border-color: var(--hm-accent);
}

/* Clinical Note Image Upload */
.record-image-upload-zone {
  margin-top: 16px;
  width: 100%;
}

.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 24px;
  border: 2px dashed var(--hm-border);
  border-radius: 12px;
  color: var(--hm-text-muted);
  cursor: pointer;
  transition: all 0.2s ease;
  background: rgba(255, 255, 255, 0.03);
}

.upload-placeholder:hover {
  border-color: var(--hm-accent);
  color: var(--hm-accent);
  background: rgba(var(--hm-accent-rgb), 0.05);
}

.record-image-preview-container {
  position: relative;
  width: 100%;
  max-height: 300px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid var(--hm-border);
}

.record-image-preview-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.remove-preview-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(4px);
  transition: all 0.2s ease;
}

.remove-preview-btn:hover {
  background: var(--hm-danger);
  transform: scale(1.1);
}

/* HealthMap Card Image Preview */
.hm-record-image-preview {
  width: 100%;
  min-height: 150px;
  max-height: 320px;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 16px;
  cursor: zoom-in;
  border: 1px solid var(--hm-border);
  background: rgba(255, 255, 255, 0.03);
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hm-record-image-preview:hover {
  transform: scale(1.01);
}

.hm-record-image-preview img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  display: block;
  border-radius: 8px;
}

.record-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
}

.record-save-btn {
  padding: 6px 16px;
  border-radius: 8px;
  border: none;
  background: var(--hm-accent);
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  font-family: "Poppins", sans-serif;
  transition: opacity 0.2s ease;
}

.record-save-btn:hover {
  opacity: 0.85;
}

.record-save-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.record-cancel-btn {
  padding: 6px 16px;
  border-radius: 8px;
  border: 1px solid var(--hm-border);
  background: transparent;
  color: var(--hm-text-muted);
  font-size: 12px;
  cursor: pointer;
  font-family: "Poppins", sans-serif;
  transition: all 0.2s ease;
}

.record-cancel-btn:hover {
  border-color: var(--hm-text-muted);
}

/* ═══════════════════════════════════════════════════════════
   Empty State
   ═══════════════════════════════════════════════════════════ */
.healthmap-empty {
  text-align: center;
  padding: 60px 20px;
  color: var(--hm-text-muted);
}

.healthmap-empty-icon {
  font-size: 48px;
  margin-bottom: 12px;
  opacity: 0.4;
}

.healthmap-empty-text {
  font-size: 15px;
  font-weight: 500;
}

.healthmap-empty-sub {
  font-size: 13px;
  margin-top: 4px;
}

/* ═══════════════════════════════════════════════════════════
   Loading Skeleton
   ═══════════════════════════════════════════════════════════ */
@keyframes shimmer {
  0% {
    background-position: -200px 0;
  }

  100% {
    background-position: 200px 0;
  }
}

.hm-skeleton {
  background: linear-gradient(90deg, var(--hm-border) 25%, var(--hm-surface-hover) 50%, var(--hm-border) 75%);
  background-size: 400px 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 8px;
  height: 80px;
  margin-bottom: 16px;
}

/* ═══════════════════════════════════════════════════════════
   Scrollbar for healthmap
   ═══════════════════════════════════════════════════════════ */
.hm-overlay-panel::-webkit-scrollbar {
  width: 4px;
}

.hm-overlay-panel::-webkit-scrollbar-track {
  background: transparent;
}

.hm-overlay-panel::-webkit-scrollbar-thumb {
  background: var(--hm-border-hover);
  border-radius: 4px;
}

/* ═══════════════════════════════════════════════════════════
   New Patient Form & Search Results
   ═══════════════════════════════════════════════════════════ */

.search-no-results {
  padding: 16px;
  text-align: center;
}

.add-patient-prompt {
  margin-top: 12px;
  background: var(--hm-accent-soft);
  color: var(--hm-accent);
  border: 1px solid var(--hm-accent);
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
}

.add-patient-prompt:hover {
  background: var(--hm-accent);
  color: white;
  transform: translateY(-2px);
}

.new-patient-form-container {
  margin-top: 32px;
  width: 100%;
  max-width: 500px;
  animation: slideDown 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.new-patient-form {
  background: var(--hm-surface);
  border: 1px solid var(--hm-border);
  border-radius: 20px;
  padding: 24px;
  box-shadow: var(--hm-card-shadow);
  backdrop-filter: blur(10px);
}

.form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.form-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: var(--hm-text);
}

.close-form {
  background: none;
  border: none;
  color: var(--hm-text-muted);
  font-size: 20px;
  cursor: pointer;
  padding: 4px;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 24px;
}

.form-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-field.full {
  grid-column: span 2;
}

.form-field label {
  font-size: 12px;
  font-weight: 600;
  color: var(--hm-text-secondary);
  margin-left: 4px;
}

.field-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.swap-btn {
  font-size: 10px;
  background: var(--hm-accent-soft);
  color: var(--hm-accent);
  border: none;
  padding: 2px 6px;
  border-radius: 4px;
  cursor: pointer;
}

.form-field input,
.form-field select {
  background: var(--hm-bg);
  border: 1px solid var(--hm-border);
  border-radius: 10px;
  padding: 10px 12px;
  color: var(--hm-text);
  font-size: 14px;
  outline: none;
  transition: all 0.2s ease;
  width: 100%;
}

.form-field input:focus,
.form-field select:focus {
  border-color: var(--hm-accent);
  box-shadow: 0 0 0 3px var(--hm-accent-soft);
}

.suggest-input {
  position: relative;
  width: 100%;
}

.mini-suggestions {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: var(--hm-surface);
  border: 1px solid var(--hm-border);
  border-radius: 8px;
  margin-top: 4px;
  z-index: 10;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  max-height: 120px;
  overflow-y: auto;
}

.mini-suggestions div {
  padding: 8px 12px;
  font-size: 13px;
  cursor: pointer;
  border-bottom: 1px solid var(--hm-border);
}

.mini-suggestions div:hover {
  background: var(--hm-surface-hover);
}

.save-patient-btn {
  width: 100%;
  background: var(--hm-accent);
  color: white;
  border: none;
  padding: 14px;
  border-radius: 12px;
  font-weight: 700;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px var(--hm-accent-soft);
}

.save-patient-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  filter: brightness(1.1);
  box-shadow: 0 6px 16px var(--hm-accent-soft);
}

.save-patient-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* ═══════════════════════════════════════════════════════════
   Custom Dropdown Styles
   ═══════════════════════════════════════════════════════════ */

.custom-dropdown {
  position: relative;
  width: 100%;
}

.dropdown-selected {
  background: var(--hm-bg);
  border: 1px solid var(--hm-border);
  border-radius: 10px;
  padding: 10px 12px;
  color: var(--hm-text-muted);
  font-size: 14px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.2s ease;
  height: 43px;
  /* Match input height */
}

.dropdown-selected.has-value {
  color: var(--hm-text);
}

.dropdown-selected:hover {
  border-color: var(--hm-border-hover);
}

.dropdown-arrow {
  font-size: 10px;
  transition: transform 0.2s ease;
  opacity: 0.5;
}

.dropdown-arrow.open {
  transform: rotate(180deg);
}

.dropdown-options {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: var(--hm-surface);
  border: 1px solid var(--hm-border);
  border-radius: 12px;
  margin-top: 6px;
  z-index: 100;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  animation: dropdownFade 0.2s ease;
}

@keyframes dropdownFade {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.dropdown-option {
  padding: 12px 16px;
  font-size: 14px;
  color: var(--hm-text);
  cursor: pointer;
  transition: all 0.15s ease;
}

.dropdown-option:hover {
  background: var(--hm-accent-soft);
  color: var(--hm-accent);
}

.dropdown-option.active {
  background: var(--hm-accent);
  color: white;
}

/* ═══════════════════════════════════════════════════════════
   Sticky Stacking Effect
   ═══════════════════════════════════════════════════════════ */

.healthmap-entry.sticky-stack {
  position: sticky;
  /* top = banner (16) + banner height (~80) + index * header height (54) */
  top: calc(110px + (var(--stack-index) * 54px));
  z-index: calc(100 + var(--stack-index));
  background: transparent;
  transition: transform 0.3s ease;
  margin-bottom: 40px;
  /* Space between cards in non-sticky state */
}

/* Add a subtle shadow when cards overlap */
.healthmap-entry.sticky-stack .hm-card {
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.05), var(--hm-card-shadow);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.healthmap-entry.sticky-stack:hover .hm-card {
  transform: translateY(-4px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12);
}

/* Ensure the date stays with the card */
.healthmap-entry.sticky-stack .healthmap-date {
  position: sticky;
  top: 0;
  height: fit-content;
}

/* Transition for smooth stacking */
.hm-card-container {
  width: 100%;
}

/* Custom styling for What's Next in sticky state */
.today-milestone.hm-card {
  background: var(--hm-today-bg);
  border: 1px solid var(--hm-today-border);
}

.today-milestone.hm-card .hm-card-header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  margin-bottom: 16px;
  padding-bottom: 8px;
}

.today-milestone.hm-card .hm-card-type {
  color: var(--hm-accent);
  font-weight: 800;
  font-size: 14px;
}

/* Responsive adjustments for stacking */
@media (max-height: 800px) {
  .healthmap-entry.sticky-stack {
    top: calc(100px + (var(--stack-index) * 44px));
  }
}

/* Clinical Note Visibility Badges */
.hm-visibility-badge {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  padding: 4px 10px;
  border-radius: 6px;
  letter-spacing: 0.5px;
}

.hm-visibility-badge.private {
  background: var(--hm-accent-soft);
  color: var(--hm-accent);
  border: 1px solid rgba(230, 33, 33, 0.1);
}

.hm-visibility-badge.collaborative {
  background: rgba(34, 139, 230, 0.1);
  color: #228BE6;
  border: 1px solid rgba(34, 139, 230, 0.1);
}

/* Visibility Save Buttons */
.record-save-btn.private {
  background: var(--hm-text);
  color: var(--hm-surface);
}

.record-save-btn.private:hover:not(:disabled) {
  background: var(--hm-text-secondary);
}

.record-save-btn.collaborative {
  background: var(--hm-accent);
  color: #fff;
}

.record-save-btn.collaborative:hover:not(:disabled) {
  background: #c21a1a;
}

/* Prominent Edit Note Button */
.hm-edit-prominent-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  background: var(--hm-surface);
  color: var(--hm-text-secondary);
  border: 1px solid var(--hm-border);
  padding: 5px 12px;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

.hm-edit-prominent-btn:hover {
  background: var(--hm-surface-hover);
  border-color: var(--hm-accent);
  color: var(--hm-accent);
  transform: translateY(-1px);
}

/* ─── Report Card Styles ─── */
.hm-report-file-box {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: var(--hm-surface-hover);
  border: 1px solid var(--hm-border);
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 8px;
}

.hm-report-file-box:hover {
  border-color: var(--hm-accent);
  background: var(--hm-surface);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.hm-report-file-box .file-icon {
  font-size: 28px;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--hm-surface);
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.03);
}

.hm-report-file-box .file-info {
  flex: 1 1;
  min-width: 0;
}

.hm-report-file-box .file-name {
  font-size: 15px;
  font-weight: 700;
  color: var(--hm-text);
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.hm-report-file-box .file-meta {
  font-size: 12px;
  color: var(--hm-text-muted);
  font-weight: 500;
}

.hm-report-file-box .file-download-arrow {
  font-size: 18px;
  color: var(--hm-text-muted);
  opacity: 0.5;
  transition: all 0.2s ease;
}

.hm-report-file-box:hover .file-download-arrow {
  color: var(--hm-accent);
  opacity: 1;
  transform: translateX(3px);
}

.hm-card-type.report {
  color: #6366f1;
}



.banner-2x2-matrix {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.matrix-btn {
  padding: 7px 14px;
  border-radius: 12px;
  border: 1px solid var(--hm-border);
  background: var(--hm-surface);
  color: var(--hm-text);
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.matrix-btn:hover {
  background: var(--hm-accent-soft);
  border-color: var(--hm-accent);
  color: var(--hm-accent);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.banner-action-group {
  display: flex;
  flex-direction: column;
  background: var(--hm-surface);
  border: 1px solid var(--hm-border);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  min-width: 150px;
}

.banner-action-group button {
  border: none !important;
  border-radius: 0 !important;
  padding: 8px 16px !important;
  width: 100% !important;
  justify-content: flex-start !important;
  background: transparent !important;
  color: var(--hm-text) !important;
  font-size: 11px !important;
  font-weight: 600 !important;
  transition: all 0.2s ease !important;
  margin: 0 !important;
}

.banner-action-group button:not(:last-child) {
  border-bottom: 1px solid var(--hm-border) !important;
}

.banner-action-group button:hover {
  background: var(--hm-accent-soft) !important;
  color: var(--hm-accent) !important;
  transform: none !important;
}

.banner-action-group button svg,
.banner-action-group button i {
  margin-right: 8px;
  flex-shrink: 0;
}

.banner-action-group button:hover svg {
  transform: scale(1.1);
}

/* =========================================================================
   Mobile Responsive Adjustments
   ========================================================================= */
@media (max-width: 768px) {
  /* Page background adjustments */
  .healthmap-page {
    padding-top: 8px;
  }

  /* Patient Banner Stack */
  .patient-banner {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
    margin: 0 12px 20px;
    padding: 16px;
    border-radius: 16px;
  }

  .patient-banner-left {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;
    width: 100%;
  }

  .hyperapt-brand-logo {
    border-right: none;
    padding-right: 0;
    margin-right: 0;
  }

  .patient-banner-main {
    flex-basis: 100%;
    margin-top: 4px;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .patient-banner-name {
    font-size: 18px;
  }

  .patient-banner-tags {
    gap: 6px;
  }

  .patient-tag {
    font-size: 10px;
    padding: 2px 8px;
  }

  .patient-banner-right {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
    border-top: 1px solid var(--hm-border);
    padding-top: 16px;
    width: 100%;
  }

  .patient-location {
    border-right: none;
    padding-right: 0;
    justify-content: space-between;
  }

  .patient-banner-actions {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .banner-action-group {
    width: 100%;
    min-width: unset;
  }

  .banner-theme-wrapper {
    justify-content: space-between;
    padding: 8px 12px;
  }

  /* HealthMap List & Line Alignment on Left */
  .healthmap-container {
    padding: 16px 12px 80px;
  }

  .healthmap-list {
    padding-left: 28px;
  }

  .healthmap-line,
  .healthmap-line-fill {
    left: 12px;
  }

  .healthmap-entry {
    padding-left: 12px;
    padding-bottom: 24px;
  }

  /* Date rendered ABOVE the card */
  .healthmap-date {
    position: static;
    width: auto;
    text-align: left;
    margin-bottom: 8px;
    display: flex;
    align-items: baseline;
    gap: 6px;
    font-size: 11px;
  }

  .healthmap-date-day {
    font-size: 12px;
    font-weight: 700;
  }

  /* What's Next Milestone adjustments */
  .today-milestone {
    padding: 16px;
    border-radius: 16px;
  }

  .today-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
    margin-bottom: 16px;
  }

  .today-header .header-divider {
    display: none;
  }

  .today-label {
    margin-top: 0;
    font-size: 11px;
  }

  .today-actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }

  .today-action-btn {
    padding: 10px 8px;
    font-size: 11px;
    justify-content: center;
    text-align: center;
    width: 100%;
    gap: 6px;
    border-radius: 8px;
  }

  .today-filter-container {
    grid-column: 1 / -1;
    margin-left: 0;
    width: 100%;
  }

  .today-filter-btn {
    width: 100%;
    justify-content: center;
    padding: 10px 12px;
    font-size: 12px;
  }

  .today-filter-dropdown {
    left: 0 !important;
    right: 0 !important;
    min-width: unset !important;
    max-width: 100% !important;
    transform-origin: top center !important;
  }

  /* Card and Inner Content adjustments for max width */
  .hm-card {
    padding: 16px;
    border-radius: 12px;
  }

  .hm-card-header {
    margin-bottom: 8px;
  }

  .hm-health-records {
    gap: 8px;
  }

  .hm-hr-item {
    padding: 8px 10px;
  }

  .hm-medicine-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
    padding: 8px 10px;
  }

  .hm-med-details {
    width: 100%;
    justify-content: space-between;
  }

  .hm-diagram-grid {
    grid-template-columns: repeat(auto-fill, minmax(68px, 1fr));
    gap: 8px;
  }

  /* Search Phase adjustments */
  .search-phase {
    padding: 24px 16px;
  }

  .search-title {
    font-size: 24px;
    margin-bottom: 8px;
  }

  .search-subtitle {
    font-size: 14px;
    margin-bottom: 24px;
    text-align: center;
  }

  .search-input {
    font-size: 15px;
    padding: 14px 16px 14px 44px;
    border-radius: 14px;
  }

  .search-icon {
    left: 14px;
  }

  /* New Patient Form Form-grid Stack */
  .new-patient-form {
    padding: 16px;
    border-radius: 16px;
  }

  .form-grid {
    grid-template-columns: 1fr;
    gap: 12px;
    margin-bottom: 16px;
  }

  .form-field.full {
    grid-column: span 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Doctor/HealthMap/HealthMap.css"],"names":[],"mappings":"AAAA;;gEAEgE;AAChE;;EAEE,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;EACpB,0BAA0B;EAC1B,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,wBAAwB;EACxB,oBAAoB;EACpB,sBAAsB;EACtB,4BAA4B;EAC5B,uEAAuE;EACvE,yCAAyC;EACzC,mCAAmC;EACnC,+EAA+E;EAC/E,uFAAuF;EACvF,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB;EACtB,uCAAuC;EACvC,0BAA0B;EAC1B,4CAA4C;EAC5C,0CAA0C;EAC1C,2CAA2C;EAC3C,8CAA8C;EAC9C,yCAAyC;AAC3C;;AAEA;;EAEE,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;EACpB,0BAA0B;EAC1B,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,wBAAwB;EACxB,oBAAoB;EACpB,sBAAsB;EACtB,8BAA8B;EAC9B,uEAAuE;EACvE,2CAA2C;EAC3C,mCAAmC;EACnC,+CAA+C;EAC/C,qDAAqD;EACrD,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB;EACtB,oCAAoC;EACpC,0BAA0B;EAC1B,yCAAyC;EACzC,sCAAsC;EACtC,4CAA4C;EAC5C,+CAA+C;EAC/C,0CAA0C;AAC5C;;AAEA;;gEAEgE;AAChE;EACE,iBAAiB;EACjB,wBAAwB;EACxB,iDAAiD;EACjD;;;wGAGsG;EACtG,qBAAqB;EACrB,iDAAiD;EACjD,kCAAkC;EAClC,wBAAwB;EACxB,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,YAAY;AACd;;AAEA;;gEAEgE;AAChE;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;gEAEgE;AAChE;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;;gEAEgE;AAChE;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,mBAAmB;EACnB,kCAAkC;EAClC,+BAA+B;EAC/B,qBAAqB;EACrB,eAAe;EACf,kCAAkC;EAClC,aAAa;EACb,iDAAiD;EACjD,2CAA2C;AAC7C;;AAEA;EACE,8BAA8B;EAC9B,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,OAAO;EACP,QAAQ;EACR,6BAA6B;EAC7B,mBAAmB;EACnB,kCAAkC;EAClC,2CAA2C;EAC3C,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;;gEAEgE;AAChE;EACE,kCAAkC;EAClC,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;;EAEnB,gCAAgC;EAChC;;;;uCAIqC;EACrC,sBAAsB;;EAEtB,gBAAgB;EAChB,SAAS;EACT,YAAY;;EAEZ,0CAA0C;EAC1C,kDAAkD;;EAElD,4CAA4C;EAC5C;;sBAEoB;AACtB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yCAAyC;EACzC,YAAY;AACd;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;EAC9C,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;;EAEE,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;;EAEE,8CAA8C;EAC9C,iCAAiC;AACnC;;AAEA;;EAEE,qBAAqB;EACrB,iCAAiC;EACjC,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;;EAGE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kCAAkC;EAClC,6BAA6B;EAC7B,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;gEAEgE;AAChE;EACE,wBAAwB;EACxB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;gEAEgE;AAChE;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,SAAS;EACT,UAAU;EACV,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,qBAAqB;EACrB,UAAU;EACV;;;mBAGiB;EACjB,UAAU;EACV,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,+BAA+B;EAC/B,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;EAC9C,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,yCAAyC;EACzC,WAAW;EACX,mDAAmD;EACnD,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;;EAEE,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;gEAEgE;AAChE;EACE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,kCAAkC;EAClC,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,iCAAiC;EACjC,wDAAwD;EACxD,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,uCAAuC;EACvC,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,+CAA+C;EAC/C,gDAAgD;AAClD;;AAEA;;gEAEgE;AAChE;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;;;;;;;;;;EAUE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,+BAA+B;EAC/B,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;;gEAEgE;AAChE;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,oGAAoG;EACpG,qBAAqB;EACrB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;gEAEgE;AAChE;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,mCAAmC;EACnC,kBAAkB;EAClB,kCAAkC;EAClC,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;;gEAEgE;AAChE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;EAC5B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;gEAEgE;AAChE;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;EAEE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;;EAEE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;;gEAEgE;AAChE;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,kCAAkC;EAClC,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,SAAO;EACP,WAAW;EACX,yEAAyE;AAC3E;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,6BAA6B;EAC7B,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kDAAkD;EAClD,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,cAAc;EACd,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,8CAA8C;AAChD;;AAEA;;gEAEgE;AAChE;EACE,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,6BAA6B;EAC7B,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kDAAkD;EAClD,kCAAkC;EAClC,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;EACnC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;EAC9B,8CAA8C;AAChD;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,0EAA0E;EAC1E,2BAA2B;EAC3B,mCAAmC;EACnC,aAAa;EACb,YAAY;EACZ,mEAAmE;AACrE;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,OAAO;EACP,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iDAAiD;EACjD,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;gEAEgE;AAChE;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,mCAAmC;EACnC,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,4BAA4B;EAC5B,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;gEAEgE;AAChE;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA;;gEAEgE;AAChE;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,kCAAkC;EAClC,wBAAwB;EACxB,qBAAqB;EACrB,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kCAAkC;EAClC,qCAAqC;EACrC,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,4BAA4B;EAC5B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;EACf,eAAe;EACf,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;gEAEgE;AAChE;EACE,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;;gEAEgE;AAChE;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,2GAA2G;EAC3G,2BAA2B;EAC3B,gCAAgC;EAChC,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;gEAEgE;AAChE;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;;gEAEgE;;AAEhE;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,uBAAuB;EACvB,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,uDAAuD;AACzD;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,wBAAwB;EACxB,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,yCAAyC;EACzC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;gEAEgE;;AAEhE;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,2CAA2C;EAC3C,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,YAAY;AACd;;AAEA;;gEAEgE;;AAEhE;EACE,gBAAgB;EAChB,yEAAyE;EACzE,8CAA8C;EAC9C,uCAAuC;EACvC,uBAAuB;EACvB,+BAA+B;EAC/B,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA,2CAA2C;AAC3C;EACE,kEAAkE;EAClE,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA,wCAAwC;AACxC;EACE,gBAAgB;EAChB,MAAM;EACN,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,WAAW;AACb;;AAEA,mDAAmD;AACnD;EACE,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,wCAAwC;AACxC;EACE;IACE,8CAA8C;EAChD;AACF;;AAEA,oCAAoC;AACpC;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,yCAAyC;AAC3C;;AAEA,4BAA4B;AAC5B;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,6BAA6B;EAC7B,+BAA+B;EAC/B,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;EAC9B,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mCAAmC;EACnC,kCAAkC;EAClC,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;;;AAIA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kCAAkC;EAClC,6BAA6B;EAC7B,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,uBAAuB;EACvB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,sCAAsC;EACtC,kCAAkC;EAClC,gCAAgC;EAChC,0BAA0B;EAC1B,2BAA2B;EAC3B,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,4CAA4C;EAC5C,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;8EAE8E;AAC9E;EACE,gCAAgC;EAChC;IACE,gBAAgB;EAClB;;EAEA,yBAAyB;EACzB;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,mBAAmB;IACnB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,sCAAsC;IACtC,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;IAC9B,iBAAiB;EACnB;;EAEA,4CAA4C;EAC5C;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA,iCAAiC;EACjC;IACE,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,qBAAqB;IACrB,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA,sCAAsC;EACtC;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,WAAW;EACb;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;IAC3B,0BAA0B;IAC1B,uCAAuC;EACzC;;EAEA,qDAAqD;EACrD;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,2DAA2D;IAC3D,QAAQ;EACV;;EAEA,6BAA6B;EAC7B;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA,qCAAqC;EACrC;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/* ═══════════════════════════════════════════════════════════\n   HEALTHMAP — Theme Variables\n   ═══════════════════════════════════════════════════════════ */\n.healthmap-page[data-theme=\"light\"],\n.hm-theme-light {\n  --hm-bg: #F8F9FA;\n  --hm-surface: #FFFFFF;\n  --hm-surface-hover: #F1F3F5;\n  --hm-text: #212529;\n  --hm-text-secondary: #495057;\n  --hm-text-muted: #ADB5BD;\n  --hm-border: #E9ECEF;\n  --hm-border-hover: #DEE2E6;\n  --hm-line: #E9ECEF;\n  --hm-line-fill: #E62121;\n  --hm-dot: #DEE2E6;\n  --hm-dot-active: #E62121;\n  --hm-accent: #E62121;\n  --hm-accent-2: #e34444;\n  --hm-accent-rgb: 230, 33, 33;\n  --hm-accent-gradient: linear-gradient(135deg, #E62121 0%, #FF6B6B 100%);\n  --hm-accent-soft: rgba(230, 33, 33, 0.08);\n  --hm-overlay-bg: rgba(0, 0, 0, 0.4);\n  --hm-card-shadow: 0 2px 8px rgba(0, 0, 0, 0.04), 0 8px 16px rgba(0, 0, 0, 0.04);\n  --hm-card-shadow-hover: 0 4px 12px rgba(0, 0, 0, 0.06), 0 12px 24px rgba(0, 0, 0, 0.06);\n  --hm-rx-accent: #E62121;\n  --hm-rcpt-accent: #228BE6;\n  --hm-order-accent: #40C057;\n  --hm-record-accent: #FAB005;\n  --hm-image-accent: #10B981;\n  /* Emerald Green */\n  --hm-treatment-accent: #6366F1;\n  /* Indigo Blue */\n  --hm-search-bg: #FFFFFF;\n  --hm-tag-bg: #F1F3F5;\n  --hm-tag-text: #495057;\n  --hm-today-bg: rgba(255, 255, 255, 0.4);\n  /* Glassmorphism Refined */\n  --hm-banner-glass: rgba(255, 255, 255, 0.75);\n  --hm-card-glass: rgba(255, 255, 255, 0.45);\n  --hm-glass-border: rgba(255, 255, 255, 0.4);\n  --hm-glass-highlight: rgba(255, 255, 255, 0.8);\n  --hm-glass-glow: rgba(255, 255, 255, 0.4);\n}\n\n.healthmap-page[data-theme=\"dark\"],\n.hm-theme-dark {\n  --hm-bg: #101113;\n  --hm-surface: #1A1B1E;\n  --hm-surface-hover: #25262B;\n  --hm-text: #E9ECEF;\n  --hm-text-secondary: #C1C2C5;\n  --hm-text-muted: #909296;\n  --hm-border: #2C2E33;\n  --hm-border-hover: #373A40;\n  --hm-line: #2C2E33;\n  --hm-line-fill: #E62121;\n  --hm-dot: #373A40;\n  --hm-dot-active: #E62121;\n  --hm-accent: #FF6B6B;\n  --hm-accent-2: #df4a4a;\n  --hm-accent-rgb: 255, 107, 107;\n  --hm-accent-gradient: linear-gradient(135deg, #FF6B6B 0%, #FFA8A8 100%);\n  --hm-accent-soft: rgba(255, 107, 107, 0.12);\n  --hm-overlay-bg: rgba(0, 0, 0, 0.8);\n  --hm-card-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);\n  --hm-card-shadow-hover: 0 8px 24px rgba(0, 0, 0, 0.5);\n  --hm-rx-accent: #FF6B6B;\n  --hm-rcpt-accent: #4DABF7;\n  --hm-order-accent: #69DB7C;\n  --hm-record-accent: #FFD43B;\n  --hm-image-accent: #34D399;\n  /* Emerald Green */\n  --hm-treatment-accent: #818CF8;\n  /* Indigo Blue */\n  --hm-search-bg: #1A1B1E;\n  --hm-tag-bg: #25262B;\n  --hm-tag-text: #C1C2C5;\n  --hm-today-bg: rgba(26, 27, 30, 0.4);\n  /* Glassmorphism Refined */\n  --hm-banner-glass: rgba(26, 27, 30, 0.85);\n  --hm-card-glass: rgba(26, 27, 30, 0.6);\n  --hm-glass-border: rgba(255, 255, 255, 0.08);\n  --hm-glass-highlight: rgba(255, 255, 255, 0.15);\n  --hm-glass-glow: rgba(255, 255, 255, 0.05);\n}\n\n/* ═══════════════════════════════════════════════════════════\n   Base Layout\n   ═══════════════════════════════════════════════════════════ */\n.healthmap-page {\n  min-height: 100vh;\n  background: var(--hm-bg);\n  /* Added mesh gradient to enhance glassmorphism */\n  background-image:\n    radial-gradient(at 0% 0%, var(--hm-accent-soft) 0, transparent 50%),\n    radial-gradient(at 50% 0%, var(--hm-rcpt-accent-soft, rgba(34, 139, 230, 0.05)) 0, transparent 50%),\n    radial-gradient(at 100% 0%, var(--hm-order-accent-soft, rgba(64, 192, 87, 0.05)) 0, transparent 50%);\n  color: var(--hm-text);\n  transition: background 0.4s ease, color 0.4s ease;\n  font-family: \"Poppins\", sans-serif;\n  width: calc(100% + 32px);\n  margin: -16px -16px -16px -16px;\n  position: relative;\n  padding-top: 16px;\n  /* Controlled padding instead of margin gap */\n}\n\n/* Header removed as per request */\n.theme-icon {\n  font-size: 14px;\n  opacity: 0.8;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   Theme Toggle\n   ═══════════════════════════════════════════════════════════ */\n.theme-toggle {\n  width: 44px;\n  height: 24px;\n  border-radius: 12px;\n  background: var(--hm-border);\n  border: none;\n  cursor: pointer;\n  position: relative;\n  transition: background 0.3s ease;\n  flex-shrink: 0;\n}\n\n.theme-toggle::after {\n  content: \"\";\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: var(--hm-accent);\n  transition: transform 0.3s ease;\n}\n\n.healthmap-page[data-theme=\"dark\"] .theme-toggle {\n  background: #3D3650;\n}\n\n.healthmap-page[data-theme=\"dark\"] .theme-toggle::after {\n  transform: translateX(20px);\n}\n\n/* ═══════════════════════════════════════════════════════════\n   Patient Search Phase\n   ═══════════════════════════════════════════════════════════ */\n.search-phase {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  padding: 40px 24px;\n  position: relative;\n}\n\n.search-phase-controls {\n  position: absolute;\n  top: 0;\n  /* Flush with top */\n  left: 24px;\n  right: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.search-theme-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: var(--hm-today-bg);\n  padding: 6px 12px;\n  border-radius: 12px;\n  border: 1px solid var(--hm-border);\n}\n\n/* ═══════════════════════════════════════════════════════════\n   Background Decorations\n   ═══════════════════════════════════════════════════════════ */\n.hm-bg-decorations {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  overflow: hidden;\n  z-index: 0;\n}\n\n.hm-decor-item {\n  position: absolute;\n  width: 48px;\n  height: 48px;\n  color: var(--hm-text);\n  opacity: 0.04;\n  /* Extremely subtle */\n  filter: blur(1px);\n  will-change: transform;\n}\n\n.healthmap-page[data-theme=\"dark\"] .hm-decor-item {\n  opacity: 0.08;\n  /* Slightly more visible in dark mode */\n}\n\n.search-title {\n  font-size: 32px;\n  font-weight: 800;\n  color: var(--hm-text);\n  margin-bottom: 12px;\n  letter-spacing: -1px;\n}\n\n.search-subtitle {\n  font-size: 16px;\n  color: var(--hm-text-muted);\n  margin-bottom: 40px;\n}\n\n.search-container {\n  position: relative;\n  width: 100%;\n  max-width: 520px;\n}\n\n.search-input {\n  width: 100%;\n  padding: 20px 24px 20px 56px;\n  border-radius: 20px;\n  border: 2px solid var(--hm-border);\n  background: var(--hm-search-bg);\n  color: var(--hm-text);\n  font-size: 18px;\n  font-family: \"Poppins\", sans-serif;\n  outline: none;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);\n}\n\n.search-input:focus {\n  border-color: var(--hm-accent);\n  box-shadow: 0 15px 40px rgba(230, 33, 33, 0.1);\n  transform: translateY(-2px);\n}\n\n.search-input::placeholder {\n  color: var(--hm-text-muted);\n}\n\n.search-icon {\n  position: absolute;\n  left: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--hm-text-muted);\n  pointer-events: none;\n}\n\n.search-dropdown {\n  position: absolute;\n  top: calc(100% + 12px);\n  left: 0;\n  right: 0;\n  background: var(--hm-surface);\n  border-radius: 20px;\n  border: 1px solid var(--hm-border);\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);\n  max-height: 400px;\n  overflow-y: auto;\n  z-index: 100;\n  padding: 8px;\n  backdrop-filter: blur(20px);\n}\n\n.search-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 18px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border-radius: 12px;\n  margin-bottom: 4px;\n}\n\n.search-item:last-child {\n  margin-bottom: 0;\n}\n\n.search-item:hover {\n  background: var(--hm-accent);\n}\n\n.search-item:hover .search-item-name,\n.search-item:hover .search-item-phone,\n.search-item:hover .search-item-city {\n  color: #FFFFFF;\n}\n\n.search-item-name {\n  font-weight: 500;\n  font-size: 14px;\n  color: var(--hm-text);\n}\n\n.search-item-phone {\n  font-size: 13px;\n  color: var(--hm-text-muted);\n  font-family: monospace;\n}\n\n.search-item-city {\n  font-size: 12px;\n  color: var(--hm-text-muted);\n}\n\n.search-loading {\n  padding: 20px;\n  text-align: center;\n  color: var(--hm-text-muted);\n  font-size: 13px;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   Patient Banner\n   ═══════════════════════════════════════════════════════════ */\n.patient-banner {\n  background: var(--hm-banner-glass);\n  border: 1px solid var(--hm-glass-border);\n  border-radius: 24px;\n  padding: 12px 24px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0 24px 32px;\n\n  /* Advanced Glass Shadow Stack */\n  box-shadow:\n    0 12px 30px rgba(0, 0, 0, 0.08),\n    inset 1px 1px 0px var(--hm-glass-highlight),\n    /* Light hit on top-left edge */\n    inset 0 0 12px var(--hm-glass-glow);\n  /* Subtle inner glow */\n\n  position: sticky;\n  top: 16px;\n  z-index: 100;\n\n  backdrop-filter: blur(28px) saturate(200%);\n  -webkit-backdrop-filter: blur(28px) saturate(200%);\n\n  /* Simulated light refraction on left side */\n  background-image: linear-gradient(110deg,\n      rgba(255, 255, 255, 0.1) 0%,\n      transparent 40%);\n}\n\n/* ─── Firm Branding: Hyperapt (Header) ─── */\n.hyperapt-brand-logo {\n  display: flex;\n  align-items: center;\n  margin-right: 12px;\n  padding-right: 12px;\n  border-right: 1px solid var(--hm-border);\n  cursor: default;\n}\n\n.firm-primary {\n  font-size: 24px;\n  font-weight: 300;\n  color: var(--hm-accent);\n}\n\n/* ─── Remade Integrated Feature Title (Strict Axis) ─── */\n.today-header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 28px;\n  /* Parent container centering */\n}\n\n.healthmap-integrated-logo {\n  display: flex;\n  align-items: center;\n  height: 22px;\n  /* Fixed height for the entire wordmark axis */\n}\n\n.healthmap-integrated-logo .feature-mark-pulse {\n  width: 24px;\n  height: 22px;\n  /* Matches text height exactly */\n  color: var(--hm-text);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: -4px;\n}\n\n.healthmap-integrated-logo .feature-mark-pulse svg {\n  width: 20px;\n  /* Scaled to sit inside the 22px height */\n  height: 20px;\n}\n\n.healthmap-integrated-logo .brand-primary,\n.healthmap-integrated-logo .brand-secondary {\n  font-size: 22px;\n  font-weight: 600;\n  color: var(--hm-text);\n  letter-spacing: -0.6px;\n  line-height: 22px;\n  /* Matches height exactly */\n  display: block;\n}\n\n.healthmap-integrated-logo .brand-secondary {\n  font-weight: 400;\n  color: var(--hm-text);\n}\n\n.header-divider {\n  height: 16px;\n  width: 1.5px;\n  background-color: var(--hm-border);\n  opacity: 0.8;\n  border-radius: 2px;\n}\n\n.today-label {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--hm-accent);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  line-height: 0px;\n  /* Matches logo height exactly for alignment */\n  display: block;\n  opacity: 0.9;\n  margin-top: 18px;\n}\n\n/* Sidebar Toggle Overrides */\n.patient-banner button.flex,\n.search-phase-controls button.flex {\n  background: transparent !important;\n  color: var(--hm-text) !important;\n}\n\n.patient-banner button.flex:hover,\n.search-phase-controls button.flex:hover {\n  background: var(--hm-surface-hover) !important;\n  transform: scale(1.05) !important;\n}\n\n.patient-banner button.flex svg,\n.search-phase-controls button.flex svg {\n  fill: none !important;\n  stroke: var(--hm-text) !important;\n  /* Menu icon uses stroke, not fill */\n  transition: stroke 0.3s ease;\n}\n\n.patient-banner button.flex svg path,\n.search-phase-controls button.flex svg path {\n  stroke: var(--hm-text) !important;\n}\n\n.patient-banner-left {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n\n.patient-banner-main {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.patient-banner-name {\n  font-size: 20px;\n  /* Slightly smaller */\n  font-weight: 700;\n  color: var(--hm-text);\n  letter-spacing: -0.5px;\n  margin: 0;\n}\n\n.patient-banner-tags {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.patient-tag {\n  font-size: 11px;\n  font-weight: 600;\n  padding: 2px 10px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.patient-tag.age,\n.patient-tag.gender,\n.patient-tag.phone {\n  background: var(--hm-tag-bg);\n  color: var(--hm-tag-text);\n}\n\n.patient-banner-right {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n}\n\n.patient-location {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding-right: 24px;\n  border-right: 1px solid var(--hm-border);\n}\n\n.location-icon {\n  font-size: 18px;\n  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.05));\n}\n\n.location-city {\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--hm-text);\n}\n\n.location-pin {\n  font-size: 11px;\n  color: var(--hm-text-muted);\n  font-weight: 500;\n}\n\n.patient-banner-actions {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.banner-theme-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: var(--hm-bg);\n  padding: 4px 10px;\n  border-radius: 10px;\n  border: 1px solid var(--hm-border);\n}\n\n.change-patient-btn {\n  padding: 8px 16px;\n  border-radius: 10px;\n  border: 1px solid var(--hm-border);\n  background: var(--hm-surface);\n  color: var(--hm-text);\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.change-patient-btn:hover {\n  background: var(--hm-accent-soft);\n  border-color: var(--hm-accent);\n  color: var(--hm-accent);\n  transform: translateY(-2px);\n}\n\n/* ═══════════════════════════════════════════════════════════\n   HealthMap Container\n   ═══════════════════════════════════════════════════════════ */\n.healthmap-container {\n  padding: 32px 24px 100px;\n  max-width: 1000px;\n  margin: 0 auto;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   HealthMap Bar & Milestones\n   ═══════════════════════════════════════════════════════════ */\n.healthmap-list {\n  position: relative;\n  padding-left: 140px;\n}\n\n.healthmap-line {\n  position: absolute;\n  left: 138px;\n  top: 11px;\n  bottom: 0;\n  width: 4px;\n  background: var(--hm-line);\n  border-radius: 4px;\n}\n\n.healthmap-line-fill {\n  position: absolute;\n  left: 138px;\n  bottom: 0;\n  /* Anchor to bottom */\n  width: 4px;\n  background: linear-gradient(to top,\n      var(--hm-accent-soft) 0%,\n      var(--hm-accent) 70%,\n      #ff6b6b 100%);\n  z-index: 5;\n  border-radius: 2px;\n  transform-origin: bottom;\n  will-change: height;\n  box-shadow: 0 0 15px rgba(230, 33, 33, 0.4);\n}\n\n.healthmap-line-fill::after {\n  content: \"\";\n  position: absolute;\n  top: -4px;\n  /* Dot at the top of the fill */\n  left: 50%;\n  transform: translateX(-50%);\n  width: 8px;\n  height: 8px;\n  background: #ff6b6b;\n  border-radius: 50%;\n  box-shadow: 0 0 10px #ff6b6b, 0 0 20px #ff6b6b;\n  z-index: 6;\n}\n\n.healthmap-entry {\n  position: relative;\n  padding-bottom: 20px;\n  padding-left: 48px;\n  animation: entryFadeIn 0.5s ease-out both;\n  z-index: 10;\n  /* Added perspective here for children transforms */\n  perspective: 1200px;\n}\n\n.healthmap-entry.today-entry {\n  z-index: 50;\n}\n\n.healthmap-entry.today-entry.filter-open,\n.healthmap-entry.today-entry:has(.today-filter-dropdown) {\n  z-index: 500;\n}\n\n@keyframes entryFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.healthmap-date {\n  position: absolute;\n  left: -140px;\n  top: 2px;\n  width: 120px;\n  text-align: right;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--hm-text-muted);\n  line-height: 1.3;\n}\n\n.healthmap-date-day {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--hm-text-secondary);\n}\n\n.healthmap-line,\n.healthmap-line-fill {\n  left: 130px;\n  /* Shifted left slightly since dots are gone */\n}\n\n.healthmap-dot.record {\n  border-color: var(--hm-record-accent);\n}\n\n/* ═══════════════════════════════════════════════════════════\n   HealthMap Cards\n   ═══════════════════════════════════════════════════════════ */\n.hm-card-wrapper {\n  will-change: transform, opacity;\n  transform-style: preserve-3d;\n}\n\n.hm-card {\n  background: var(--hm-card-glass);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  border-radius: 16px;\n  border: 1px solid var(--hm-glass-border);\n  padding: 20px;\n  box-shadow: var(--hm-card-shadow);\n  transition: box-shadow 0.3s ease, border-color 0.3s ease;\n  cursor: default;\n  position: relative;\n  overflow: hidden;\n  will-change: transform, opacity;\n}\n\n.hm-card:hover {\n  box-shadow: var(--hm-card-shadow-hover);\n  border-color: var(--hm-accent);\n  transform: translateY(-2px);\n}\n\n.hm-card::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 4px;\n  background: transparent;\n  transition: background 0.3s ease;\n}\n\n.hm-card.prescription:hover::before {\n  background: var(--hm-rx-accent);\n}\n\n.hm-card.receipt:hover::before {\n  background: var(--hm-rcpt-accent);\n}\n\n.hm-card.order:hover::before {\n  background: var(--hm-order-accent);\n}\n\n.hm-card.record:hover::before {\n  background: var(--hm-record-accent);\n}\n\n.hm-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.hm-card-type {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.hm-card-type.prescription {\n  color: var(--hm-rx-accent);\n}\n\n.hm-card-type.receipt {\n  color: var(--hm-rcpt-accent);\n}\n\n.hm-card-type.order {\n  color: var(--hm-order-accent);\n}\n\n.hm-card-type.record {\n  color: var(--hm-record-accent);\n}\n\n.hm-card-id {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--hm-text-muted);\n  font-family: monospace;\n}\n\n.hm-card-body {\n  font-size: 13px;\n  color: var(--hm-text-secondary);\n  line-height: 1.5;\n}\n\n.hm-card-row {\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n  margin-bottom: 4px;\n}\n\n.hm-card-label {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--hm-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  flex-shrink: 0;\n}\n\n.hm-card-value {\n  font-size: 13px;\n  color: var(--hm-text);\n}\n\n.hm-card-products {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin-top: 6px;\n}\n\n.hm-product-pill {\n  font-size: 11px;\n  padding: 2px 8px;\n  border-radius: 6px;\n  background: var(--hm-accent-soft);\n  color: var(--hm-text-secondary);\n  white-space: nowrap;\n}\n\n.hm-card-actions {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 12px;\n  padding-top: 10px;\n  border-top: 1px solid var(--hm-border);\n}\n\n.hm-action-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  border: none;\n  background: transparent;\n  color: var(--hm-text-muted);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 14px;\n}\n\n.hm-action-btn:hover {\n  background: var(--hm-accent-soft);\n  color: var(--hm-accent);\n}\n\n.hm-action-whatsapp:hover {\n  background: rgba(37, 211, 102, 0.1);\n}\n\n.hm-action-whatsapp-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.hm-action-whatsapp-btn:hover {\n  background: rgba(37, 211, 102, 0.12) !important;\n  border-color: rgba(37, 211, 102, 0.3) !important;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   Prescription Health Records (in card)\n   ═══════════════════════════════════════════════════════════ */\n.hm-health-records {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 10px;\n}\n\n.hm-hr-item {\n  padding: 6px 8px;\n  border-radius: 8px;\n  background: var(--hm-bg);\n  border: 1px solid var(--hm-border);\n}\n\n.hm-hr-item.hr-complaints,\n.hm-hr-item.hr-diagnosis,\n.hm-hr-item.hr-measurements,\n.hm-hr-item.hr-tests,\n.hm-hr-item.hr-advice,\n.hm-hr-item.hr-observations,\n.hm-hr-item.hr-notes,\n.hm-hr-item.hr-nextvisit,\n.hm-hr-item.hr-diagrams,\n.hm-hr-item.hr-medicines {\n  border-left: 3px solid var(--hm-border-hover);\n}\n\n.hm-hr-header {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  margin-bottom: 3px;\n}\n\n.hm-hr-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border-radius: 4px;\n  flex-shrink: 0;\n}\n\n.hr-complaints .hm-hr-icon {\n  color: #E62121;\n}\n\n.hr-diagnosis .hm-hr-icon {\n  color: #0F52BA;\n}\n\n.hr-measurements .hm-hr-icon {\n  color: #D97706;\n}\n\n.hr-tests .hm-hr-icon {\n  color: #6366F1;\n}\n\n.hr-advice .hm-hr-icon {\n  color: #00C732;\n}\n\n.hr-observations .hm-hr-icon {\n  color: #9333EA;\n}\n\n.hr-notes .hm-hr-icon {\n  color: #6B7280;\n}\n\n.hr-nextvisit .hm-hr-icon {\n  color: #3B82F6;\n}\n\n.hr-diagrams .hm-hr-icon {\n  color: #6366F1;\n}\n\n.hr-medicines .hm-hr-icon {\n  color: #0D9488;\n}\n\n.hm-hr-label {\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--hm-text-muted);\n}\n\n.hm-hr-pills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 3px;\n}\n\n.hm-hr-pill {\n  font-size: 11px;\n  padding: 1px 7px;\n  border-radius: 5px;\n  background: var(--hm-surface);\n  color: var(--hm-text-secondary);\n  border: 1px solid var(--hm-border);\n  white-space: nowrap;\n}\n\n.hm-hr-text {\n  font-size: 12px;\n  color: var(--hm-text-secondary);\n  line-height: 1.4;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   Diagrams Grid\n   ═══════════════════════════════════════════════════════════ */\n.hm-diagram-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));\n  gap: 10px;\n  margin-top: 4px;\n}\n\n.hm-diagram-preview {\n  position: relative;\n  aspect-ratio: 1;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid var(--hm-border);\n  cursor: zoom-in;\n  background: #fff;\n  transition: all 0.2s ease;\n}\n\n.hm-diagram-preview:hover {\n  transform: scale(1.05);\n  border-color: var(--hm-accent);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.hm-diagram-preview img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.hm-diagram-info {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: linear-gradient(to top, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0.4) 60%, transparent 100%);\n  padding: 12px 6px 6px;\n  display: flex;\n  flex-direction: column;\n}\n\n.hm-diag-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n\n.hm-diag-title {\n  color: #fff;\n  font-size: 10px;\n  font-weight: 700;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.hm-diag-sub {\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 8px;\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.hm-diag-val {\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 8px;\n  font-weight: 600;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-top: 1px;\n}\n\n.hm-hr-item.hr-images {\n  border-color: rgba(16, 185, 129, 0.2);\n  background: rgba(16, 185, 129, 0.03);\n}\n\n.hm-hr-item.hr-images .hm-hr-label {\n  color: var(--hm-image-accent);\n}\n\n.hm-hr-item.hr-images .hm-hr-icon {\n  color: var(--hm-image-accent);\n}\n\n.hm-diagram-preview.patient-image {\n  border-radius: 12px;\n  border: 1.5px solid rgba(16, 185, 129, 0.15);\n}\n\n.hm-diagram-preview.patient-image:hover {\n  border-color: var(--hm-image-accent);\n  transform: scale(1.02);\n}\n\n.hm-hr-item.hr-treatment {\n  border-color: rgba(99, 102, 241, 0.2);\n  background: rgba(99, 102, 241, 0.03);\n}\n\n.hm-hr-item.hr-treatment .hm-hr-label {\n  color: var(--hm-treatment-accent);\n}\n\n.hm-hr-item.hr-treatment .hm-hr-icon {\n  color: var(--hm-treatment-accent);\n}\n\n/* ═══════════════════════════════════════════════════════════\n   Medicine Card Styles\n   ═══════════════════════════════════════════════════════════ */\n.medicine-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px !important;\n}\n\n.hm-medicine-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 12px;\n  background: var(--hm-surface-hover);\n  border-radius: 8px;\n  border: 1px solid var(--hm-border);\n  gap: 12px;\n}\n\n.hm-med-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--hm-text);\n  flex: 1;\n}\n\n.hm-med-details {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-shrink: 0;\n}\n\n.hm-med-dosage {\n  font-size: 12px;\n  color: var(--hm-rx-accent);\n  font-weight: 600;\n  background: var(--hm-accent-soft);\n  padding: 2px 8px;\n  border-radius: 4px;\n}\n\n.hm-med-days {\n  font-size: 11px;\n  color: var(--hm-text-muted);\n  font-weight: 500;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   Doctor Tag\n   ═══════════════════════════════════════════════════════════ */\n.doctor-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  padding: 3px 10px;\n  border-radius: 6px;\n  background: var(--hm-tag-bg);\n  color: var(--hm-tag-text);\n  margin-top: 8px;\n  font-weight: 500;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   Order Status Badge\n   ═══════════════════════════════════════════════════════════ */\n.order-status {\n  font-size: 11px;\n  font-weight: 600;\n  padding: 2px 8px;\n  border-radius: 6px;\n  text-transform: uppercase;\n}\n\n.order-status.delivered,\n.order-status.collected {\n  background: rgba(0, 199, 50, 0.12);\n  color: #00C732;\n}\n\n.order-status.packed,\n.order-status.dispatched {\n  background: rgba(15, 82, 186, 0.12);\n  color: #0F52BA;\n}\n\n.order-status.accepted {\n  background: rgba(199, 166, 0, 0.12);\n  color: #C7A600;\n}\n\n.order-status.cancelled {\n  background: rgba(230, 33, 33, 0.12);\n  color: #E62121;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   Today Milestone\n   ═══════════════════════════════════════════════════════════ */\n.today-milestone {\n  background: var(--hm-today-bg);\n  border-radius: 20px;\n  border: 1px solid var(--hm-border);\n  padding: 24px;\n  box-shadow: var(--hm-card-shadow);\n}\n\n.today-label {\n  font-size: 12px;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 1.5px;\n  color: var(--hm-accent);\n  margin-bottom: 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.today-label::after {\n  content: \"\";\n  flex: 1;\n  height: 1px;\n  background: linear-gradient(to right, var(--hm-accent-soft), transparent);\n}\n\n.today-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.today-action-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 18px;\n  border-radius: 12px;\n  border: 1px solid var(--hm-border);\n  background: var(--hm-surface);\n  color: var(--hm-text);\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n  font-family: \"Poppins\", sans-serif;\n  white-space: nowrap;\n}\n\n.today-action-btn:hover {\n  border-color: var(--hm-accent);\n  background: var(--hm-accent);\n  color: #FFFFFF;\n  transform: translateY(-3px);\n  box-shadow: 0 8px 20px rgba(230, 33, 33, 0.2);\n}\n\n.today-action-btn.studio-jump {\n  border-style: dashed;\n  color: var(--hm-text-secondary);\n}\n\n.today-action-btn.studio-jump:hover {\n  background: linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%);\n  border-color: transparent;\n  border-style: solid;\n  color: #FFFFFF;\n  box-shadow: 0 8px 20px rgba(99, 102, 241, 0.3);\n}\n\n/* ═══════════════════════════════════════════════════════════\n   HealthMap Timeline Filters Dropdown\n   ═══════════════════════════════════════════════════════════ */\n.today-filter-container {\n  position: relative;\n  display: inline-flex;\n  z-index: 50;\n}\n\n.today-filter-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  border-radius: 12px;\n  border: 1px solid var(--hm-border);\n  background: var(--hm-surface);\n  color: var(--hm-text);\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n  font-family: \"Poppins\", sans-serif;\n  user-select: none;\n  white-space: nowrap;\n}\n\n.today-filter-btn:hover {\n  border-color: var(--hm-border-hover);\n  background: var(--hm-surface-hover);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n\n.today-filter-btn.open {\n  border-color: var(--hm-accent);\n  box-shadow: 0 4px 14px rgba(230, 33, 33, 0.15);\n}\n\n.today-filter-btn.is-filtered {\n  border-color: var(--hm-accent);\n  background: var(--hm-accent-soft);\n  color: var(--hm-accent);\n}\n\n.today-filter-btn .today-filter-icon {\n  flex-shrink: 0;\n  opacity: 0.85;\n}\n\n.today-filter-badge {\n  font-size: 11px;\n  font-weight: 700;\n  padding: 2px 7px;\n  border-radius: 8px;\n  letter-spacing: 0.3px;\n  transition: all 0.2s ease;\n}\n\n.today-filter-badge.all {\n  background: var(--hm-tag-bg);\n  color: var(--hm-text-secondary);\n}\n\n.today-filter-badge.filtered {\n  background: var(--hm-accent);\n  color: #FFFFFF;\n  box-shadow: 0 2px 6px rgba(230, 33, 33, 0.3);\n}\n\n.today-filter-chevron {\n  font-size: 9px;\n  opacity: 0.6;\n  transition: transform 0.25s ease;\n  margin-left: 2px;\n}\n\n.today-filter-chevron.open {\n  transform: rotate(180deg);\n}\n\n/* Dropdown Popover */\n.today-filter-dropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  min-width: 290px;\n  max-width: 330px;\n  background: var(--hm-surface);\n  border: 1px solid var(--hm-border);\n  border-radius: 16px;\n  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.22), 0 4px 16px rgba(0, 0, 0, 0.1);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  padding: 12px;\n  z-index: 500;\n  animation: hmFilterDropdownFade 0.22s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.today-filter-dropdown.align-right {\n  right: 0;\n  left: auto;\n  transform-origin: top right;\n}\n\n.today-filter-dropdown.align-left {\n  left: 0;\n  right: auto;\n  transform-origin: top left;\n}\n\n@keyframes hmFilterDropdownFade {\n  from {\n    opacity: 0;\n    transform: scale(0.95) translateY(-6px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n.today-filter-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 4px 6px 10px 8px;\n  border-bottom: 1px solid var(--hm-border);\n  margin-bottom: 8px;\n}\n\n.today-filter-title {\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--hm-text);\n  letter-spacing: -0.2px;\n}\n\n.today-filter-toggle-btn {\n  background: transparent;\n  border: none;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--hm-accent);\n  cursor: pointer;\n  padding: 3px 8px;\n  border-radius: 6px;\n  font-family: \"Poppins\", sans-serif;\n  transition: background 0.2s ease;\n}\n\n.today-filter-toggle-btn:hover {\n  background: var(--hm-accent-soft);\n}\n\n.today-filter-list {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.today-filter-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 9px 10px;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.18s ease;\n  user-select: none;\n}\n\n.today-filter-item:hover {\n  background: var(--hm-surface-hover);\n}\n\n.today-filter-item.selected {\n  background: rgba(var(--hm-accent-rgb), 0.04);\n}\n\n.today-filter-item-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.today-filter-checkbox {\n  width: 18px;\n  height: 18px;\n  border-radius: 5px;\n  border: 1.8px solid var(--hm-border-hover);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  background: var(--hm-bg);\n  flex-shrink: 0;\n}\n\n.today-filter-checkbox.checked {\n  background: var(--hm-accent);\n  border-color: var(--hm-accent);\n  color: #FFFFFF;\n}\n\n.today-filter-item-icon {\n  font-size: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.today-filter-item-label {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--hm-text);\n}\n\n.today-filter-item-count {\n  font-size: 11px;\n  font-weight: 600;\n  padding: 2px 7px;\n  border-radius: 10px;\n  background: var(--hm-tag-bg);\n  color: var(--hm-tag-text);\n  min-width: 22px;\n  text-align: center;\n}\n\n.today-filter-item-count.zero {\n  opacity: 0.45;\n}\n\n.today-filter-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 8px 2px;\n  border-top: 1px solid var(--hm-border);\n  margin-top: 8px;\n}\n\n.today-filter-footer-text {\n  font-size: 11px;\n  color: var(--hm-text-muted);\n}\n\n.today-filter-reset-link {\n  background: transparent;\n  border: none;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--hm-accent);\n  cursor: pointer;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-family: \"Poppins\", sans-serif;\n}\n\n.today-filter-reset-link:hover {\n  text-decoration: underline;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   Overlay (for Prescription/Receipt/PDF)\n   ═══════════════════════════════════════════════════════════ */\n.hm-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  background: var(--hm-overlay-bg);\n  animation: overlayFadeIn 0.3s ease;\n}\n\n@keyframes overlayFadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n.hm-overlay-panel {\n  background: var(--hm-surface);\n  border-radius: 16px;\n  width: 95%;\n  max-width: 860px;\n  max-height: 92vh;\n  overflow-y: auto;\n  box-shadow: 0 16px 64px rgba(0, 0, 0, 0.2);\n  animation: panelSlideUp 0.35s ease;\n  position: relative;\n}\n\n@keyframes panelSlideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.hm-overlay-close {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: none;\n  background: var(--hm-border);\n  color: var(--hm-text-secondary);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  transition: all 0.2s ease;\n  z-index: 10;\n}\n\n.hm-overlay-close:hover {\n  background: var(--hm-accent);\n  color: #fff;\n}\n\n.hm-overlay-title {\n  font-size: 18px;\n  font-weight: 600;\n  padding: 20px 24px 0;\n  color: var(--hm-text);\n}\n\n.hm-overlay-body {\n  padding: 16px 24px 24px;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   PDF Overlay\n   ═══════════════════════════════════════════════════════════ */\n.pdf-overlay-frame {\n  width: 100%;\n  height: 75vh;\n  border: none;\n  border-radius: 8px;\n  background: #fff;\n}\n\n.pdf-overlay-actions {\n  display: flex;\n  gap: 8px;\n  padding: 16px 24px;\n  border-top: 1px solid var(--hm-border);\n  justify-content: center;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   Record Editor\n   ═══════════════════════════════════════════════════════════ */\n.record-textarea {\n  width: 100%;\n  min-height: 80px;\n  padding: 12px;\n  border-radius: 8px;\n  border: 1px solid var(--hm-border);\n  background: var(--hm-bg);\n  color: var(--hm-text);\n  font-size: 13px;\n  font-family: \"Poppins\", sans-serif;\n  resize: vertical;\n  outline: none;\n  transition: border-color 0.2s ease;\n}\n\n.record-textarea:focus {\n  border-color: var(--hm-accent);\n}\n\n/* Clinical Note Image Upload */\n.record-image-upload-zone {\n  margin-top: 16px;\n  width: 100%;\n}\n\n.upload-placeholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 24px;\n  border: 2px dashed var(--hm-border);\n  border-radius: 12px;\n  color: var(--hm-text-muted);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  background: rgba(255, 255, 255, 0.03);\n}\n\n.upload-placeholder:hover {\n  border-color: var(--hm-accent);\n  color: var(--hm-accent);\n  background: rgba(var(--hm-accent-rgb), 0.05);\n}\n\n.record-image-preview-container {\n  position: relative;\n  width: 100%;\n  max-height: 300px;\n  border-radius: 12px;\n  overflow: hidden;\n  border: 1px solid var(--hm-border);\n}\n\n.record-image-preview-container img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.remove-preview-btn {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: rgba(0, 0, 0, 0.6);\n  color: white;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  backdrop-filter: blur(4px);\n  transition: all 0.2s ease;\n}\n\n.remove-preview-btn:hover {\n  background: var(--hm-danger);\n  transform: scale(1.1);\n}\n\n/* HealthMap Card Image Preview */\n.hm-record-image-preview {\n  width: 100%;\n  min-height: 150px;\n  max-height: 320px;\n  border-radius: 12px;\n  overflow: hidden;\n  margin-bottom: 16px;\n  cursor: zoom-in;\n  border: 1px solid var(--hm-border);\n  background: rgba(255, 255, 255, 0.03);\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.hm-record-image-preview:hover {\n  transform: scale(1.01);\n}\n\n.hm-record-image-preview img {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n  display: block;\n  border-radius: 8px;\n}\n\n.record-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 12px;\n}\n\n.record-save-btn {\n  padding: 6px 16px;\n  border-radius: 8px;\n  border: none;\n  background: var(--hm-accent);\n  color: #fff;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  font-family: \"Poppins\", sans-serif;\n  transition: opacity 0.2s ease;\n}\n\n.record-save-btn:hover {\n  opacity: 0.85;\n}\n\n.record-save-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.record-cancel-btn {\n  padding: 6px 16px;\n  border-radius: 8px;\n  border: 1px solid var(--hm-border);\n  background: transparent;\n  color: var(--hm-text-muted);\n  font-size: 12px;\n  cursor: pointer;\n  font-family: \"Poppins\", sans-serif;\n  transition: all 0.2s ease;\n}\n\n.record-cancel-btn:hover {\n  border-color: var(--hm-text-muted);\n}\n\n/* ═══════════════════════════════════════════════════════════\n   Empty State\n   ═══════════════════════════════════════════════════════════ */\n.healthmap-empty {\n  text-align: center;\n  padding: 60px 20px;\n  color: var(--hm-text-muted);\n}\n\n.healthmap-empty-icon {\n  font-size: 48px;\n  margin-bottom: 12px;\n  opacity: 0.4;\n}\n\n.healthmap-empty-text {\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.healthmap-empty-sub {\n  font-size: 13px;\n  margin-top: 4px;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   Loading Skeleton\n   ═══════════════════════════════════════════════════════════ */\n@keyframes shimmer {\n  0% {\n    background-position: -200px 0;\n  }\n\n  100% {\n    background-position: 200px 0;\n  }\n}\n\n.hm-skeleton {\n  background: linear-gradient(90deg, var(--hm-border) 25%, var(--hm-surface-hover) 50%, var(--hm-border) 75%);\n  background-size: 400px 100%;\n  animation: shimmer 1.5s infinite;\n  border-radius: 8px;\n  height: 80px;\n  margin-bottom: 16px;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   Scrollbar for healthmap\n   ═══════════════════════════════════════════════════════════ */\n.hm-overlay-panel::-webkit-scrollbar {\n  width: 4px;\n}\n\n.hm-overlay-panel::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.hm-overlay-panel::-webkit-scrollbar-thumb {\n  background: var(--hm-border-hover);\n  border-radius: 4px;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   New Patient Form & Search Results\n   ═══════════════════════════════════════════════════════════ */\n\n.search-no-results {\n  padding: 16px;\n  text-align: center;\n}\n\n.add-patient-prompt {\n  margin-top: 12px;\n  background: var(--hm-accent-soft);\n  color: var(--hm-accent);\n  border: 1px solid var(--hm-accent);\n  padding: 8px 16px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  width: 100%;\n}\n\n.add-patient-prompt:hover {\n  background: var(--hm-accent);\n  color: white;\n  transform: translateY(-2px);\n}\n\n.new-patient-form-container {\n  margin-top: 32px;\n  width: 100%;\n  max-width: 500px;\n  animation: slideDown 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.new-patient-form {\n  background: var(--hm-surface);\n  border: 1px solid var(--hm-border);\n  border-radius: 20px;\n  padding: 24px;\n  box-shadow: var(--hm-card-shadow);\n  backdrop-filter: blur(10px);\n}\n\n.form-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.form-header h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--hm-text);\n}\n\n.close-form {\n  background: none;\n  border: none;\n  color: var(--hm-text-muted);\n  font-size: 20px;\n  cursor: pointer;\n  padding: 4px;\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.form-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.form-field.full {\n  grid-column: span 2;\n}\n\n.form-field label {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--hm-text-secondary);\n  margin-left: 4px;\n}\n\n.field-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.swap-btn {\n  font-size: 10px;\n  background: var(--hm-accent-soft);\n  color: var(--hm-accent);\n  border: none;\n  padding: 2px 6px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.form-field input,\n.form-field select {\n  background: var(--hm-bg);\n  border: 1px solid var(--hm-border);\n  border-radius: 10px;\n  padding: 10px 12px;\n  color: var(--hm-text);\n  font-size: 14px;\n  outline: none;\n  transition: all 0.2s ease;\n  width: 100%;\n}\n\n.form-field input:focus,\n.form-field select:focus {\n  border-color: var(--hm-accent);\n  box-shadow: 0 0 0 3px var(--hm-accent-soft);\n}\n\n.suggest-input {\n  position: relative;\n  width: 100%;\n}\n\n.mini-suggestions {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: var(--hm-surface);\n  border: 1px solid var(--hm-border);\n  border-radius: 8px;\n  margin-top: 4px;\n  z-index: 10;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  max-height: 120px;\n  overflow-y: auto;\n}\n\n.mini-suggestions div {\n  padding: 8px 12px;\n  font-size: 13px;\n  cursor: pointer;\n  border-bottom: 1px solid var(--hm-border);\n}\n\n.mini-suggestions div:hover {\n  background: var(--hm-surface-hover);\n}\n\n.save-patient-btn {\n  width: 100%;\n  background: var(--hm-accent);\n  color: white;\n  border: none;\n  padding: 14px;\n  border-radius: 12px;\n  font-weight: 700;\n  font-size: 15px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 4px 12px var(--hm-accent-soft);\n}\n\n.save-patient-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  filter: brightness(1.1);\n  box-shadow: 0 6px 16px var(--hm-accent-soft);\n}\n\n.save-patient-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   Custom Dropdown Styles\n   ═══════════════════════════════════════════════════════════ */\n\n.custom-dropdown {\n  position: relative;\n  width: 100%;\n}\n\n.dropdown-selected {\n  background: var(--hm-bg);\n  border: 1px solid var(--hm-border);\n  border-radius: 10px;\n  padding: 10px 12px;\n  color: var(--hm-text-muted);\n  font-size: 14px;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transition: all 0.2s ease;\n  height: 43px;\n  /* Match input height */\n}\n\n.dropdown-selected.has-value {\n  color: var(--hm-text);\n}\n\n.dropdown-selected:hover {\n  border-color: var(--hm-border-hover);\n}\n\n.dropdown-arrow {\n  font-size: 10px;\n  transition: transform 0.2s ease;\n  opacity: 0.5;\n}\n\n.dropdown-arrow.open {\n  transform: rotate(180deg);\n}\n\n.dropdown-options {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: var(--hm-surface);\n  border: 1px solid var(--hm-border);\n  border-radius: 12px;\n  margin-top: 6px;\n  z-index: 100;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);\n  overflow: hidden;\n  animation: dropdownFade 0.2s ease;\n}\n\n@keyframes dropdownFade {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.dropdown-option {\n  padding: 12px 16px;\n  font-size: 14px;\n  color: var(--hm-text);\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.dropdown-option:hover {\n  background: var(--hm-accent-soft);\n  color: var(--hm-accent);\n}\n\n.dropdown-option.active {\n  background: var(--hm-accent);\n  color: white;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   Sticky Stacking Effect\n   ═══════════════════════════════════════════════════════════ */\n\n.healthmap-entry.sticky-stack {\n  position: sticky;\n  /* top = banner (16) + banner height (~80) + index * header height (54) */\n  top: calc(110px + (var(--stack-index) * 54px));\n  z-index: calc(100 + var(--stack-index));\n  background: transparent;\n  transition: transform 0.3s ease;\n  margin-bottom: 40px;\n  /* Space between cards in non-sticky state */\n}\n\n/* Add a subtle shadow when cards overlap */\n.healthmap-entry.sticky-stack .hm-card {\n  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.05), var(--hm-card-shadow);\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.healthmap-entry.sticky-stack:hover .hm-card {\n  transform: translateY(-4px);\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12);\n}\n\n/* Ensure the date stays with the card */\n.healthmap-entry.sticky-stack .healthmap-date {\n  position: sticky;\n  top: 0;\n  height: fit-content;\n}\n\n/* Transition for smooth stacking */\n.hm-card-container {\n  width: 100%;\n}\n\n/* Custom styling for What's Next in sticky state */\n.today-milestone.hm-card {\n  background: var(--hm-today-bg);\n  border: 1px solid var(--hm-today-border);\n}\n\n.today-milestone.hm-card .hm-card-header {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n  margin-bottom: 16px;\n  padding-bottom: 8px;\n}\n\n.today-milestone.hm-card .hm-card-type {\n  color: var(--hm-accent);\n  font-weight: 800;\n  font-size: 14px;\n}\n\n/* Responsive adjustments for stacking */\n@media (max-height: 800px) {\n  .healthmap-entry.sticky-stack {\n    top: calc(100px + (var(--stack-index) * 44px));\n  }\n}\n\n/* Clinical Note Visibility Badges */\n.hm-visibility-badge {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  padding: 4px 10px;\n  border-radius: 6px;\n  letter-spacing: 0.5px;\n}\n\n.hm-visibility-badge.private {\n  background: var(--hm-accent-soft);\n  color: var(--hm-accent);\n  border: 1px solid rgba(230, 33, 33, 0.1);\n}\n\n.hm-visibility-badge.collaborative {\n  background: rgba(34, 139, 230, 0.1);\n  color: #228BE6;\n  border: 1px solid rgba(34, 139, 230, 0.1);\n}\n\n/* Visibility Save Buttons */\n.record-save-btn.private {\n  background: var(--hm-text);\n  color: var(--hm-surface);\n}\n\n.record-save-btn.private:hover:not(:disabled) {\n  background: var(--hm-text-secondary);\n}\n\n.record-save-btn.collaborative {\n  background: var(--hm-accent);\n  color: #fff;\n}\n\n.record-save-btn.collaborative:hover:not(:disabled) {\n  background: #c21a1a;\n}\n\n/* Prominent Edit Note Button */\n.hm-edit-prominent-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: var(--hm-surface);\n  color: var(--hm-text-secondary);\n  border: 1px solid var(--hm-border);\n  padding: 5px 12px;\n  border-radius: 8px;\n  font-size: 11px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);\n}\n\n.hm-edit-prominent-btn:hover {\n  background: var(--hm-surface-hover);\n  border-color: var(--hm-accent);\n  color: var(--hm-accent);\n  transform: translateY(-1px);\n}\n\n/* ─── Report Card Styles ─── */\n.hm-report-file-box {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 16px;\n  background: var(--hm-surface-hover);\n  border: 1px solid var(--hm-border);\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  margin-top: 8px;\n}\n\n.hm-report-file-box:hover {\n  border-color: var(--hm-accent);\n  background: var(--hm-surface);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n\n.hm-report-file-box .file-icon {\n  font-size: 28px;\n  width: 48px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--hm-surface);\n  border-radius: 10px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.03);\n}\n\n.hm-report-file-box .file-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.hm-report-file-box .file-name {\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--hm-text);\n  margin-bottom: 2px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.hm-report-file-box .file-meta {\n  font-size: 12px;\n  color: var(--hm-text-muted);\n  font-weight: 500;\n}\n\n.hm-report-file-box .file-download-arrow {\n  font-size: 18px;\n  color: var(--hm-text-muted);\n  opacity: 0.5;\n  transition: all 0.2s ease;\n}\n\n.hm-report-file-box:hover .file-download-arrow {\n  color: var(--hm-accent);\n  opacity: 1;\n  transform: translateX(3px);\n}\n\n.hm-card-type.report {\n  color: #6366f1;\n}\n\n\n\n.banner-2x2-matrix {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px;\n}\n\n.matrix-btn {\n  padding: 7px 14px;\n  border-radius: 12px;\n  border: 1px solid var(--hm-border);\n  background: var(--hm-surface);\n  color: var(--hm-text);\n  font-size: 11px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  white-space: nowrap;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n}\n\n.matrix-btn:hover {\n  background: var(--hm-accent-soft);\n  border-color: var(--hm-accent);\n  color: var(--hm-accent);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n}\n\n.banner-action-group {\n  display: flex;\n  flex-direction: column;\n  background: var(--hm-surface);\n  border: 1px solid var(--hm-border);\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  min-width: 150px;\n}\n\n.banner-action-group button {\n  border: none !important;\n  border-radius: 0 !important;\n  padding: 8px 16px !important;\n  width: 100% !important;\n  justify-content: flex-start !important;\n  background: transparent !important;\n  color: var(--hm-text) !important;\n  font-size: 11px !important;\n  font-weight: 600 !important;\n  transition: all 0.2s ease !important;\n  margin: 0 !important;\n}\n\n.banner-action-group button:not(:last-child) {\n  border-bottom: 1px solid var(--hm-border) !important;\n}\n\n.banner-action-group button:hover {\n  background: var(--hm-accent-soft) !important;\n  color: var(--hm-accent) !important;\n  transform: none !important;\n}\n\n.banner-action-group button svg,\n.banner-action-group button i {\n  margin-right: 8px;\n  flex-shrink: 0;\n}\n\n.banner-action-group button:hover svg {\n  transform: scale(1.1);\n}\n\n/* =========================================================================\n   Mobile Responsive Adjustments\n   ========================================================================= */\n@media (max-width: 768px) {\n  /* Page background adjustments */\n  .healthmap-page {\n    padding-top: 8px;\n  }\n\n  /* Patient Banner Stack */\n  .patient-banner {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 16px;\n    margin: 0 12px 20px;\n    padding: 16px;\n    border-radius: 16px;\n  }\n\n  .patient-banner-left {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 12px;\n    width: 100%;\n  }\n\n  .hyperapt-brand-logo {\n    border-right: none;\n    padding-right: 0;\n    margin-right: 0;\n  }\n\n  .patient-banner-main {\n    flex-basis: 100%;\n    margin-top: 4px;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n  }\n\n  .patient-banner-name {\n    font-size: 18px;\n  }\n\n  .patient-banner-tags {\n    gap: 6px;\n  }\n\n  .patient-tag {\n    font-size: 10px;\n    padding: 2px 8px;\n  }\n\n  .patient-banner-right {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 16px;\n    border-top: 1px solid var(--hm-border);\n    padding-top: 16px;\n    width: 100%;\n  }\n\n  .patient-location {\n    border-right: none;\n    padding-right: 0;\n    justify-content: space-between;\n  }\n\n  .patient-banner-actions {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n  }\n\n  .banner-action-group {\n    width: 100%;\n    min-width: unset;\n  }\n\n  .banner-theme-wrapper {\n    justify-content: space-between;\n    padding: 8px 12px;\n  }\n\n  /* HealthMap List & Line Alignment on Left */\n  .healthmap-container {\n    padding: 16px 12px 80px;\n  }\n\n  .healthmap-list {\n    padding-left: 28px;\n  }\n\n  .healthmap-line,\n  .healthmap-line-fill {\n    left: 12px;\n  }\n\n  .healthmap-entry {\n    padding-left: 12px;\n    padding-bottom: 24px;\n  }\n\n  /* Date rendered ABOVE the card */\n  .healthmap-date {\n    position: static;\n    width: auto;\n    text-align: left;\n    margin-bottom: 8px;\n    display: flex;\n    align-items: baseline;\n    gap: 6px;\n    font-size: 11px;\n  }\n\n  .healthmap-date-day {\n    font-size: 12px;\n    font-weight: 700;\n  }\n\n  /* What's Next Milestone adjustments */\n  .today-milestone {\n    padding: 16px;\n    border-radius: 16px;\n  }\n\n  .today-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 6px;\n    margin-bottom: 16px;\n  }\n\n  .today-header .header-divider {\n    display: none;\n  }\n\n  .today-label {\n    margin-top: 0;\n    font-size: 11px;\n  }\n\n  .today-actions {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 8px;\n  }\n\n  .today-action-btn {\n    padding: 10px 8px;\n    font-size: 11px;\n    justify-content: center;\n    text-align: center;\n    width: 100%;\n    gap: 6px;\n    border-radius: 8px;\n  }\n\n  .today-filter-container {\n    grid-column: 1 / -1;\n    margin-left: 0;\n    width: 100%;\n  }\n\n  .today-filter-btn {\n    width: 100%;\n    justify-content: center;\n    padding: 10px 12px;\n    font-size: 12px;\n  }\n\n  .today-filter-dropdown {\n    left: 0 !important;\n    right: 0 !important;\n    min-width: unset !important;\n    max-width: 100% !important;\n    transform-origin: top center !important;\n  }\n\n  /* Card and Inner Content adjustments for max width */\n  .hm-card {\n    padding: 16px;\n    border-radius: 12px;\n  }\n\n  .hm-card-header {\n    margin-bottom: 8px;\n  }\n\n  .hm-health-records {\n    gap: 8px;\n  }\n\n  .hm-hr-item {\n    padding: 8px 10px;\n  }\n\n  .hm-medicine-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 6px;\n    padding: 8px 10px;\n  }\n\n  .hm-med-details {\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .hm-diagram-grid {\n    grid-template-columns: repeat(auto-fill, minmax(68px, 1fr));\n    gap: 8px;\n  }\n\n  /* Search Phase adjustments */\n  .search-phase {\n    padding: 24px 16px;\n  }\n\n  .search-title {\n    font-size: 24px;\n    margin-bottom: 8px;\n  }\n\n  .search-subtitle {\n    font-size: 14px;\n    margin-bottom: 24px;\n    text-align: center;\n  }\n\n  .search-input {\n    font-size: 15px;\n    padding: 14px 16px 14px 44px;\n    border-radius: 14px;\n  }\n\n  .search-icon {\n    left: 14px;\n  }\n\n  /* New Patient Form Form-grid Stack */\n  .new-patient-form {\n    padding: 16px;\n    border-radius: 16px;\n  }\n\n  .form-grid {\n    grid-template-columns: 1fr;\n    gap: 12px;\n    margin-bottom: 16px;\n  }\n\n  .form-field.full {\n    grid-column: span 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
